var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpaceCjr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "46mm",
    height: "46mm",
    viewBox: "0 0 130.3937 130.3937",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.ac,.ad,.ah,.ai,.aj,.ak,.al,.d,.e,.f,.g,.h,.i,.j,.k,.l,.m,.n,.o,.p,.q,.r,.s,.x,.y{fill:none;}.b{fill:#54ef9a;}.c{fill:#ffdb06;}.d,.e,.f,.y{stroke:#ff9376;}.aj,.ak,.al,.d,.e,.f,.g,.h,.i,.j,.k,.l,.m,.n,.o,.p,.q,.r,.s{stroke-linecap:round;}.d,.e,.f{stroke-linejoin:round;}.aj,.ak,.al,.d,.p{stroke-width:2px;}.e{stroke-width:1.5px;}.f{stroke-width:0.5px;}.ai,.g,.h,.i,.j,.k,.l,.m,.n,.o,.p,.q,.r,.s{stroke:#ffdb06;}.ac,.ad,.ag,.ai,.aj,.ak,.al,.g,.h,.i,.j,.k,.l,.m,.n,.o,.p,.q,.r,.s,.y{stroke-miterlimit:10;}.g{stroke-width:0.6px;}.h{stroke-width:0.8px;}.i{stroke-width:1.2px;}.j{stroke-width:1.4px;}.k{stroke-width:1.6px;}.l{stroke-width:1.8px;}.n{stroke-width:2.4px;}.o{stroke-width:2.2px;}.q{stroke-width:2.6px;}.r{stroke-width:3px;}.s{stroke-width:2.8px;}.t{clip-path:url(#a);}.u{clip-path:url(#b);}.v{fill:#db004f;}.w{opacity:0.7;fill:url(#c);}.al,.x{stroke:#7a0032;}.ac,.ah,.x{stroke-width:12px;}.ad,.ai,.y{stroke-width:8px;}.z{clip-path:url(#d);}.aa{fill:#009b88;}.ab,.ag{opacity:0.8;}.ab{fill:url(#e);}.ac,.ak{stroke:#004743;}.ad{stroke:#54ef9a;}.ae{clip-path:url(#f);}.af{fill:#ff7300;}.ag{fill:url(#g);stroke:url(#h);}.ah,.aj{stroke:#992f20;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 65.1969,
    cy: 65.1969,
    r: 63.7698
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M121.4363,98.0462S105.0286,130.477,65.0721,130.588c-39.6924.11-56.3642-32.5419-56.3642-32.5419L65.0721,65.5043Z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "c",
    width: 106.7528,
    height: 106.7528,
    patternTransform: "translate(-154.3962 272.3263)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 106.753 106.753"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 106.7528,
    height: 106.7528
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "7.876 105.943 5.139 110.462 9.29 113.662 7.876 105.943"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "46.762 115.651 48.598 105.955 53.018 112.638"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "73.327 97.295 77.498 96.202 74.936 105.048 82.82 102.982 75.95 114.903"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 89.6456,
    y1: 111.4862,
    x2: 85.0229,
    y2: 107.156
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "100.7 108.771 101.999 115.644 104.277 107.454"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 65.606,
    y1: 113.9494,
    x2: 64.2432,
    y2: 106.6928
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 112.5773,
    y1: 64.3425,
    x2: 107.744,
    y2: 59.7056
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "100.556 90.138 112.577 93.056 106.567 87.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "5.883 20.287 8.111 11.307 13.58 16.116"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "27.441 16.866 22.464 16.608 22.319 19.409 17.341 19.151 17.196 21.952 13.15 18.934 11.913 22.99"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "6.139 82.134 10.379 84.753 11.853 82.367 16.093 84.986 17.567 82.6 19.664 87.192 22.699 84.23"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 41.7356,
    y1: 10.0519,
    x2: 43.8812,
    y2: 5.415
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 77.4353,
    y1: 49.6401,
    x2: 79.5808,
    y2: 45.0032
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 21.1106,
    y1: 12.6193,
    x2: 20.2272,
    y2: 9.5092
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 28.6978,
    y1: 13.192,
    x2: 27.4142,
    y2: 10.4276
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 62.4688,
    y1: 55.7816,
    x2: 65.016,
    y2: 54.1078
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "36.803 10.947 35.357 16.064 42.7 13.505"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "31.819 20.752 32.124 24.388 26.745 23.021 31.819 20.752"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "8.876 29.307 8.876 31.866 11.546 31.866 10.211 35.76 14.419 36.428"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "75.475 40.52 77.867 41.428 78.814 38.931 81.982 41.56 84.098 37.863"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 22.1052,
    y1: 32.5893,
    x2: 15.43,
    y2: 26.5816
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 27.8423,
    y1: 84.0098,
    x2: 24.2697,
    y2: 75.7705
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 23.1165,
    y1: 28.8623,
    x2: 31.0155,
    y2: 30.3086
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "38.779 19.973 44.12 19.083 42.451 22.421 48.904 21.387"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "37.444 24.638 37.426 29.578 40.949 28.213 42.548 33.5 48.33 28.86 48.835 32.665"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "54.28 56.54 55.397 61.352 58.512 59.215 61.282 63.994 65.844 58.151 67.209 61.739"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "28.902 34.994 37.357 38.906 22.242 40.508"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "18.169 39.631 11.647 41.158 19.677 47.322"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 10.2903,
    y1: 46.5125,
    x2: 6.1619,
    y2: 45.2984
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 35.4578,
    y1: 79.8603,
    x2: 31.3294,
    y2: 78.6462
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "12.226 51.959 18.419 51.076 16.082 55.069 23.677 56.595"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "25.523 45.298 30.459 47.322 27.066 48.905 32.017 50.432 30.409 55.831 33.762 56.595"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "51.378 8.732 60.343 7.137 58.362 13.053 64.124 13.053 63.427 17.447 72.751 16.435"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 50.4965,
    y1: 13.0643,
    x2: 52.0179,
    y2: 17.9735
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 52.1109,
    y1: 23.4041,
    x2: 62.9502,
    y2: 21.7365
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "f",
    points: "55.926 27.22 55.926 37.997 62.194 31.611"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 44.6997,
    y1: 39.6312,
    x2: 50.4965,
    y2: 36.5211
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 37.3569,
    y1: 43.4764,
    x2: 40.7502,
    y2: 47.3217
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "47.427 48.905 46.632 44.268 53.16 45.905 53.16 42.465 61.336 43.476 61.336 39.631"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "65.588 27.972 72.412 29.307 66.725 33.98 76.203 34.994"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 69.9478,
    y1: 24.1371,
    x2: 70.7506,
    y2: 20.1845
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "73.138 9.002 68.971 7.456 73.032 4.015 73.138 9.002"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "10.29 61.232 10.29 67.453 14.419 65.869 10.29 61.232"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 20.6689,
    y1: 61.2324,
    x2: 28.056,
    y2: 62.8158
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "23.767 66.23 17.934 68.355 19.448 74.586 10.83 74.245"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 7.2261,
    y1: 71.2375,
    x2: 5.1619,
    y2: 76.2533
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 5.8245,
    y1: 64.3425,
    x2: 0.9913,
    y2: 59.7056
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "28.048 73.057 30.8 68.431 32.994 74.225 34.782 63.811 38.358 68.463 38.377 63.826 43.832 63.057"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "41.028 58.179 42.808 52.674 50.497 62.816"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "50.16 53.945 50.984 50.542 56.901 50.836"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 58.9014,
    y1: 47.905,
    x2: 64.588,
    y2: 49.9469
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "69.474 40.508 70.349 51.076 73.549 50.432 69.474 40.508"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "f",
    points: "79.357 32.608 83.217 30.309 76.203 25.721 80.786 23.133 75.066 19.151"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 79.1413,
    y1: 15.6912,
    x2: 84.3541,
    y2: 14.8633
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "80.786 7.009 75.066 13.444 88.829 7.009"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "44.747 68.325 41.057 76.105 52.468 66.074"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "54.95 71.09 52.468 78.253 61.336 79.86 54.95 71.09"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 61.3359,
    y1: 68.0896,
    x2: 68.1287,
    y2: 68.0896
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "f",
    points: "44.7 79.86 42.808 91.232 37.357 83.325"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "33.394 86.663 32.124 93.491 26.745 91.985 25.27 99.14"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 22.6689,
    y1: 92.9013,
    x2: 17.43,
    y2: 97.4452
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "7.72 101.284 10.513 90.709 16.097 107.439"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "7.876 105.399 5.139 109.917 9.29 113.118 7.876 105.399"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "7.876 -0.81 5.139 3.709 9.29 6.909 7.876 -0.81"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 20.6689,
    y1: 101.3989,
    x2: 19.677,
    y2: 106.6705
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "25.27 103.093 28.842 106.671 30.409 103.093 34.937 106.671 35.688 97.445 43.842 106.671"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 41.0283,
    y1: 96.1273,
    x2: 46.6325,
    y2: 99.1396
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "48.26 83.136 49.113 89.192 54.761 84.134 53.16 94.056 59.089 90.103 61.336 99.14"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 48.2598,
    y1: 94.0563,
    x2: 50.4965,
    y2: 101.3989
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "56.916 100.14 54.16 107.671 57.531 107.671 56.916 100.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "83.217 19.151 90.646 20.185 86.931 10.563"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "f",
    points: "92.981 7.009 91.474 11.432 97.837 14.863 94.656 23.967 99.708 24.388 98.817 32.589"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "102.7 19.799 105.524 11.432 108.16 22.161 102.7 19.799"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 95.8374,
    y1: 9.006,
    x2: 98.6998,
    y2: 7.1729
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "103.43 27.22 107.854 29.585 100.7 37.751"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 88.8292,
    y1: 27.2196,
    x2: 84.3541,
    y2: 23.9671
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 93.5454,
    y1: 26.5816,
    x2: 90.6456,
    y2: 34.9943
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "88.829 46.512 86.592 34.994 97.123 51.076"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "92.21 37.751 96.318 37.751 96.318 41.56 102.582 43.035 100.7 47.322 107.007 49.926"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 107.0069,
    y1: 37.7511,
    x2: 106.1596,
    y2: 44.2681
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "83.217 47.322 81.947 51.883 90.646 49.926"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "70.091 55.519 76.596 54.572 75.599 61.569 81.693 59.882 81.439 64.812 88.514 65.355"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 84.0978,
    y1: 56.5955,
    x2: 90.6456,
    y2: 56.5955
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "93.545 53.836 97.123 63.267 88.829 61.437"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "98.472 56.248 102.814 51.599 107.257 56.852 98.472 56.248"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "f",
    points: "102.582 62.024 106.583 67.631 98.139 69.204 102.361 73.237 90.646 76.77 93.545 85.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "97.837 80.89 103.43 78.646 106.16 83.136"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 107.0069,
    y1: 73.2375,
    x2: 107.8541,
    y2: 76.7705
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "73.549 66.016 79.786 67.334 70.349 73.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "65.588 72.475 64.742 76.253 70.349 76.86 65.588 82.01 75.066 82.01"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 59.9014,
    y1: 85.0098,
    x2: 67.1045,
    y2: 89.192
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "66.861 93.618 75.668 87.794 67.988 104.404"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 64.7424,
    y1: 99.3989,
    x2: 61.3359,
    y2: 104.6705
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "46.762 115.955 48.598 106.258 53.018 112.942"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "46.762 8.898 48.598 -0.798 53.018 5.885"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "77.469 74.77 86.931 70.028 78.508 79.819"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 92.9759,
    y1: 71.0896,
    x2: 92.21,
    y2: 66.9936
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 82.2167,
    y1: 79.8186,
    x2: 87.8292,
    y2: 78.8914
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "78.508 84.663 86.297 83.546 84.098 92.056 78.508 84.663"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "73.327 -9.458 77.498 -10.55 74.936 -1.705 82.82 -3.77 75.95 8.15"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "73.327 97.707 77.498 96.614 74.936 105.46 82.82 103.394 75.95 115.315"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "84.354 99.14 86.931 96.99 91.474 102.905"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "90.646 94.056 90.646 89.192 96.016 91.624 98.614 84.134 101.999 86.663 101.999 84.134"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "100.7 90.138 112.721 93.056 106.71 87.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "-6.196 90.138 5.825 93.056 -0.186 87.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "f",
    points: "93.545 97.931 98.614 95.173 98.139 102.905 106.16 102.058 104.277 105.258 110.515 106.671"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 104.2769,
    y1: 96.4452,
    x2: 109.3603,
    y2: 96.4452
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 89.6456,
    y1: 111.4862,
    x2: 85.0229,
    y2: 107.156
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 89.6456,
    y1: 4.7335,
    x2: 85.0229,
    y2: 0.4032
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 89.5917,
    y1: 106.2585,
    x2: 98.1395,
    y2: 107.6705
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "100.7 2.019 101.999 8.891 104.277 0.701"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "12.354 1.848 16.542 9.289 18.768 3.919"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 65.606,
    y1: 113.9494,
    x2: 64.2432,
    y2: 106.6928
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 65.606,
    y1: 7.1966,
    x2: 64.2432,
    y2: -0.06
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "f",
    points: "23.873 6.711 24.914 0.994 27.184 7.914 32.299 3.376 32.299 9.793 40.408 2.348"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 7.194,
    y1: 24.3885,
    x2: 3.4079,
    y2: 27.9723
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 5.1388,
    y1: 34.9943,
    x2: 6.1619,
    y2: 41.0096
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "7.162 50.926 6.65 56.243 4.408 52.076"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "-4.053 19.799 -1.229 11.432 1.407 22.161 -4.053 19.799"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "-3.323 27.22 1.101 29.585 -6.053 37.751"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "-14.543 37.751 -10.435 37.751 -10.435 41.56 -4.17 43.035 -6.053 47.322 0.254 49.926"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 0.2541,
    y1: 37.7511,
    x2: -0.5931,
    y2: 44.2681
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "-8.281 56.248 -3.939 51.599 0.504 56.852 -8.281 56.248"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "f",
    points: "-4.17 62.024 -0.169 67.631 -8.613 69.204 -4.391 73.237 -16.107 76.77 -13.207 85.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "-8.915 80.89 -3.323 78.646 -0.593 83.136"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 0.2541,
    y1: 73.2375,
    x2: 1.1013,
    y2: 76.7705
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "-6.053 90.138 5.968 93.056 -0.043 87.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "f",
    points: "-13.207 97.931 -8.138 95.173 -8.613 102.905 -0.593 102.058 -2.476 105.258 3.763 106.671"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: -2.4758,
    y1: 96.4452,
    x2: 2.6075,
    y2: 96.4452
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "7.72 -5.468 10.513 -16.044 16.097 0.686"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "7.876 -1.354 5.139 3.165 9.29 6.365 7.876 -1.354"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 20.6689,
    y1: -5.3539,
    x2: 19.677,
    y2: -0.0822
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "25.27 -3.659 28.842 -0.082 30.409 -3.659 34.937 -0.082 35.688 -9.308 43.842 -0.082"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "56.916 -6.613 54.16 0.918 57.531 0.918 56.916 -6.613"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "46.762 9.202 48.598 -0.494 53.018 6.189"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "73.327 -9.046 77.498 -10.138 74.936 -1.293 82.82 -3.358 75.95 8.562"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "f",
    points: "93.545 -8.822 98.614 -11.58 98.139 -3.848 106.16 -4.695 104.277 -1.494 110.515 -0.082"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 89.6456,
    y1: 4.7335,
    x2: 85.0229,
    y2: 0.4032
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 89.5917,
    y1: -0.4943,
    x2: 98.1395,
    y2: 0.9178
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 65.606,
    y1: 7.1966,
    x2: 64.2432,
    y2: -0.06
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "f",
    points: "-13.207 -8.822 -8.138 -11.58 -8.613 -3.848 -0.593 -4.695 -2.476 -1.494 3.763 -0.082"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.7079,98.0463s-19.882-30.4249,0-65.0838C28.4585-1.4672,65.0721.4207,65.0721.4207V65.5044Z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "e",
    width: 106.7528,
    height: 106.7528,
    patternTransform: "translate(-146.8471 272.1226)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 106.753 106.753"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 106.7528,
    height: 106.7528
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.762,111.9759a5.218,5.218,0,1,1,5.2178-5.2183A5.2239,5.2239,0,0,1,107.762,111.9759Zm0-9.936a4.718,4.718,0,1,0,4.7178,4.7177A4.7228,4.7228,0,0,0,107.762,102.04Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 107.3781,
    cy: 106.1621,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.7622,111.9759a5.218,5.218,0,1,1,5.2178-5.2183A5.224,5.224,0,0,1,107.7622,111.9759Zm0-9.936a4.718,4.718,0,1,0,4.7178,4.7177A4.7229,4.7229,0,0,0,107.7622,102.04Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 107.3781,
    cy: 106.1621,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.0093,111.9759a5.218,5.218,0,0,1,0-10.436,5.218,5.218,0,0,1,0,10.436Zm0-9.936a4.718,4.718,0,0,0,0,9.436,4.718,4.718,0,0,0,0-9.436Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.6254,
    cy: 106.1621,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M22.7583,109.9857a4.2278,4.2278,0,1,1,4.2275-4.2281A4.2327,4.2327,0,0,1,22.7583,109.9857Zm0-8.2056a3.9778,3.9778,0,1,0,3.9775,3.9775A3.9827,3.9827,0,0,0,22.7583,101.78Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 22.3865,
    cy: 105.7579,
    r: 2.4651
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M85.5259,111.6024a4.845,4.845,0,1,1,4.3467-2.69A4.8213,4.8213,0,0,1,85.5259,111.6024Zm-1.9239-.9532a4.3442,4.3442,0,1,0-2.1865-2.5063A4.3511,4.3511,0,0,0,83.602,110.6492Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 85.5338,
    cy: 105.2848,
    r: 1.5261
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 68.0472,
    cy: 107.1401,
    r: 2.8637
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M67.9321,111.65a4.0261,4.0261,0,1,1,4.0264-4.0259A4.031,4.031,0,0,1,67.9321,111.65Zm0-7.8022a3.7761,3.7761,0,1,0,3.7764,3.7763A3.7806,3.7806,0,0,0,67.9321,103.848Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 44.6773,
    cy: 106.7579,
    r: 2.2327
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.01,111.9759a5.218,5.218,0,0,1,0-10.436,5.218,5.218,0,0,1,0,10.436Zm0-9.936a4.718,4.718,0,0,0,0,9.436,4.718,4.718,0,0,0,0-9.436Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.6254,
    cy: 106.1621,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.762,5.2231A5.2239,5.2239,0,0,1,102.5443.0049a5.2178,5.2178,0,1,1,10.4355,0A5.2239,5.2239,0,0,1,107.762,5.2231Zm0-9.936A4.7229,4.7229,0,0,0,103.0443.0049a4.7233,4.7233,0,0,0,4.7177,4.7182A4.7233,4.7233,0,0,0,112.48.0049,4.7229,4.7229,0,0,0,107.762-4.7129Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 107.3781,
    cy: -0.5907,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.762,111.9756a5.2178,5.2178,0,1,1,5.2178-5.2178A5.2238,5.2238,0,0,1,107.762,111.9756Zm0-9.9356a4.7178,4.7178,0,1,0,4.7178,4.7178A4.7229,4.7229,0,0,0,107.762,102.04Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 107.3781,
    cy: 106.1621,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M105.7435,91.7251a5.2178,5.2178,0,1,1,5.2178-5.2178A5.2238,5.2238,0,0,1,105.7435,91.7251Zm0-9.9356a4.7178,4.7178,0,1,0,4.7178,4.7178A4.7229,4.7229,0,0,0,105.7435,81.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.3255,91.3032a5.5469,5.5469,0,1,1,5.5479-5.5469A5.5531,5.5531,0,0,1,107.3255,91.3032Zm0-10.8437a5.2969,5.2969,0,1,0,5.2979,5.2968A5.3026,5.3026,0,0,0,107.3255,80.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.5716,70.17a5.0777,5.0777,0,1,1,5.0772-5.0776A5.0838,5.0838,0,0,1,107.5716,70.17Zm0-9.9053a4.8277,4.8277,0,1,0,4.8272,4.8277A4.8334,4.8334,0,0,0,107.5716,60.2646Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7552,43.3432a4.1205,4.1205,0,0,1-1.835-.4311h0a4.1422,4.1422,0,1,1,1.835.4311Zm-1.6123-.8793a3.64,3.64,0,1,0-1.6416-4.879,3.643,3.643,0,0,0,1.6416,4.879Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 108.3499,
    cy: 18.6839,
    r: 1.9125
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 106.7619,
    cy: 64.0923,
    r: 2.6579
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 107.4415,
    cy: 39.2039,
    r: 1.6797
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 106.7619,
    cy: 86.5072,
    r: 2.3164
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 11.889,
    cy: 9.0509,
    r: 2.3082
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.5454,13.5884a5.0931,5.0931,0,1,1,5.0928-5.0933A5.0985,5.0985,0,0,1,11.5454,13.5884Zm0-9.9361a4.8431,4.8431,0,1,0,4.8428,4.8428A4.8485,4.8485,0,0,0,11.5454,3.6523Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M56.1343,36.9311a5.6148,5.6148,0,1,1,5.6142-5.6147A5.6207,5.6207,0,0,1,56.1343,36.9311Zm0-10.98a5.3648,5.3648,0,1,0,5.3642,5.3648A5.3707,5.3707,0,0,0,56.1343,25.9516Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M54.9624,34.9082A5.2178,5.2178,0,1,1,60.18,29.69,5.2238,5.2238,0,0,1,54.9624,34.9082Zm0-9.9356A4.7178,4.7178,0,1,0,59.68,29.69,4.723,4.723,0,0,0,54.9624,24.9726Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M65.3979,24.96a4.5061,4.5061,0,1,1,4.5069-4.5063A4.5112,4.5112,0,0,1,65.3979,24.96Zm0-8.5122a4.0061,4.0061,0,1,0,4.0069,4.0059A4.01,4.01,0,0,0,65.3979,16.4477Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.8315,79.7988a5.2676,5.2676,0,1,1,5.2676-5.2676A5.2735,5.2735,0,0,1,12.8315,79.7988Zm0-10.0351a4.7676,4.7676,0,1,0,4.7676,4.7675A4.7728,4.7728,0,0,0,12.8315,69.7637Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M44.0581,24.8535a4.5061,4.5061,0,1,1,4.5059-4.5063A4.5113,4.5113,0,0,1,44.0581,24.8535Zm0-8.5122a4.0061,4.0061,0,1,0,4.0059,4.0059A4.01,4.01,0,0,0,44.0581,16.3413Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.8218,33.6675a4.5061,4.5061,0,1,1,4.5068-4.5059A4.5112,4.5112,0,0,1,10.8218,33.6675Zm0-8.5122a4.0061,4.0061,0,1,0,4.0068,4.0063A4.0106,4.0106,0,0,0,10.8218,25.1553Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M55.353,79.0376A4.5064,4.5064,0,1,1,59.86,74.5312,4.5113,4.5113,0,0,1,55.353,79.0376Zm0-8.5127A4.0064,4.0064,0,1,0,59.36,74.5312,4.0106,4.0106,0,0,0,55.353,70.5249Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21.5083,47.3315a6.2854,6.2854,0,1,1,6.2852-6.2851A6.2928,6.2928,0,0,1,21.5083,47.3315Zm0-12.0708a5.7854,5.7854,0,1,0,5.7852,5.7857A5.7923,5.7923,0,0,0,21.5083,35.2607Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M74.7075,100.5156a4.7988,4.7988,0,1,1,4.7988-4.7988A4.804,4.804,0,0,1,74.7075,100.5156Zm0-9.0976a4.2988,4.2988,0,1,0,4.2988,4.2988A4.3037,4.3037,0,0,0,74.7075,91.418Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.7622,111.9756a5.2178,5.2178,0,1,1,5.2178-5.2178A5.2239,5.2239,0,0,1,107.7622,111.9756Zm0-9.9356a4.7178,4.7178,0,1,0,4.7178,4.7178A4.7229,4.7229,0,0,0,107.7622,102.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M74.1323,79.167a5.0928,5.0928,0,1,1,5.0938-5.0928A5.0983,5.0983,0,0,1,74.1323,79.167Zm0-9.9356a4.8428,4.8428,0,1,0,4.8438,4.8428A4.8485,4.8485,0,0,0,74.1323,69.2314Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M75.5532,79.1968a4.86,4.86,0,1,1,4.8594-4.8594A4.8654,4.8654,0,0,1,75.5532,79.1968Zm0-9.2193a4.36,4.36,0,1,0,4.3594,4.36A4.3652,4.3652,0,0,0,75.5532,69.9775Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M23.1968,90.5229a4.0261,4.0261,0,1,1,4.0263-4.0263A4.0311,4.0311,0,0,1,23.1968,90.5229Zm0-7.8022a3.7761,3.7761,0,1,0,3.7763,3.7759A3.7805,3.7805,0,0,0,23.1968,82.7207Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M96.4614,100.3638a4.0264,4.0264,0,1,1,4.0264-4.0264A4.0312,4.0312,0,0,1,96.4614,100.3638Zm0-7.8028a3.7764,3.7764,0,1,0,3.7764,3.7764A3.7807,3.7807,0,0,0,96.4614,92.561Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M24.1353,89.521A4.1512,4.1512,0,1,1,28.2866,85.37,4.156,4.156,0,0,1,24.1353,89.521Zm0-7.8023A3.6512,3.6512,0,1,0,27.7866,85.37,3.6555,3.6555,0,0,0,24.1353,81.7187Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M105.7437,91.7251a5.2178,5.2178,0,1,1,5.2177-5.2178A5.2238,5.2238,0,0,1,105.7437,91.7251Zm0-9.9356a4.7178,4.7178,0,1,0,4.7177,4.7178A4.7229,4.7229,0,0,0,105.7437,81.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.3257,91.3032a5.5469,5.5469,0,1,1,5.5469-5.5469A5.5531,5.5531,0,0,1,107.3257,91.3032Zm0-10.8437a5.2969,5.2969,0,1,0,5.2969,5.2968A5.3026,5.3026,0,0,0,107.3257,80.46Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 55.3532,
    cy: 8.4042,
    r: 2.3082
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M55.9839,14.1426a5.0916,5.0916,0,1,1,5.0918-5.0918A5.0976,5.0976,0,0,1,55.9839,14.1426Zm0-9.9331a4.8416,4.8416,0,1,0,4.8418,4.8413A4.847,4.847,0,0,0,55.9839,4.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M76.0786,57.834A5.0916,5.0916,0,1,1,81.17,52.7427,5.0975,5.0975,0,0,1,76.0786,57.834Zm0-9.9331A4.8416,4.8416,0,1,0,80.92,52.7427,4.8471,4.8471,0,0,0,76.0786,47.9009Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M98.6938,56.4175a4.5689,4.5689,0,1,1,4.5684-4.5689A4.5744,4.5744,0,0,1,98.6938,56.4175Zm0-8.8877a4.3189,4.3189,0,1,0,4.3184,4.3188A4.3239,4.3239,0,0,0,98.6938,47.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M100.6655,56.522a5.2027,5.2027,0,1,1,5.2022-5.2027A5.2088,5.2088,0,0,1,100.6655,56.522Zm0-9.9053a4.7027,4.7027,0,1,0,4.7022,4.7026A4.7078,4.7078,0,0,0,100.6655,46.6167Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.5708,70.2949a5.2027,5.2027,0,1,1,5.2031-5.2026A5.2085,5.2085,0,0,1,107.5708,70.2949Zm0-9.9053a4.7027,4.7027,0,1,0,4.7031,4.7027A4.7075,4.7075,0,0,0,107.5708,60.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M64.0776,47.209A5.2027,5.2027,0,1,1,69.28,42.0063,5.2088,5.2088,0,0,1,64.0776,47.209Zm0-9.9053A4.7027,4.7027,0,1,0,68.78,42.0063,4.7078,4.7078,0,0,0,64.0776,37.3037Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M96.4614,12.7573A4.7779,4.7779,0,1,1,101.24,7.98,4.7833,4.7833,0,0,1,96.4614,12.7573Zm0-9.0557A4.2779,4.2779,0,1,0,100.74,7.98,4.2825,4.2825,0,0,0,96.4614,3.7016Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M33.19,58.6308a5.6755,5.6755,0,1,1,5.6758-5.6757A5.6821,5.6821,0,0,1,33.19,58.6308Zm0-11.101a5.4255,5.4255,0,1,0,5.4258,5.4253A5.4313,5.4313,0,0,0,33.19,47.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M86.6343,25.3208a6.0081,6.0081,0,1,1,6.0088-6.0078A6.0149,6.0149,0,0,1,86.6343,25.3208Zm0-11.7661a5.7581,5.7581,0,1,0,5.7588,5.7583A5.7645,5.7645,0,0,0,86.6343,13.5547Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M56.1938,103.418a5.7986,5.7986,0,1,1,5.7979-5.7989A5.8057,5.8057,0,0,1,56.1938,103.418Zm0-11.3472a5.5486,5.5486,0,1,0,5.5479,5.5483A5.5548,5.5548,0,0,0,56.1938,92.0708Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M85.5337,89.7768a4.8318,4.8318,0,1,1,4.832-4.8315A4.8374,4.8374,0,0,1,85.5337,89.7768Zm0-9.4135a4.5818,4.5818,0,1,0,4.582,4.582A4.5873,4.5873,0,0,0,85.5337,80.3633Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.5454,57.5742a4.8318,4.8318,0,1,1,4.832-4.8315A4.8375,4.8375,0,0,1,11.5454,57.5742Zm0-9.4136a4.5818,4.5818,0,1,0,4.582,4.5821A4.5874,4.5874,0,0,0,11.5454,48.1606Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M32.896,100.814a4.2281,4.2281,0,1,1,4.2285-4.2281A4.2324,4.2324,0,0,1,32.896,100.814Zm0-8.2061a3.9781,3.9781,0,1,0,3.9785,3.978A3.9822,3.9822,0,0,0,32.896,92.6079Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M44.0581,46.4834a4.2281,4.2281,0,1,1,4.2285-4.228A4.2324,4.2324,0,0,1,44.0581,46.4834Zm0-8.2061a3.9781,3.9781,0,1,0,3.9785,3.9781A3.9823,3.9823,0,0,0,44.0581,38.2773Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M76.0786,37.0884A4.2281,4.2281,0,1,1,80.3071,32.86,4.2325,4.2325,0,0,1,76.0786,37.0884Zm0-8.2061a3.9781,3.9781,0,1,0,3.9785,3.978A3.9823,3.9823,0,0,0,76.0786,28.8823Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M75.8091,98.8061a4.228,4.228,0,1,1,4.2275-4.228A4.2324,4.2324,0,0,1,75.8091,98.8061Zm0-8.206a3.978,3.978,0,1,0,3.9775,3.978A3.9823,3.9823,0,0,0,75.8091,90.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M85.8765,67.8535a4.2281,4.2281,0,1,1,4.2275-4.228A4.2325,4.2325,0,0,1,85.8765,67.8535Zm0-8.2061a3.9781,3.9781,0,1,0,3.9775,3.9781A3.9823,3.9823,0,0,0,85.8765,59.6474Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 33.7045,
    cy: 7.8338,
    r: 1.8078
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M34.3276,11.6372a4.1283,4.1283,0,0,1-1.8379-.4341h0a4.1128,4.1128,0,1,1,1.8379.4341Zm.01-7.7813a3.6392,3.6392,0,0,0-1.625,6.899h0a3.6393,3.6393,0,1,0,1.625-6.899Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M64.9907,67.7646a4.12,4.12,0,0,1-1.834-.4311h0a4.1422,4.1422,0,1,1,1.834.4311Zm.01-7.7807a3.64,3.64,0,0,0-1.6211,6.9013h0a3.64,3.64,0,1,0,1.6211-6.9013Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7573,43.3457a4.1264,4.1264,0,0,1-1.8369-.4336h0a4.115,4.115,0,1,1,1.8369.4336Zm-1.6142-.8818a3.64,3.64,0,1,0-1.6416-4.879,3.6238,3.6238,0,0,0,1.6416,4.879Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M97.228,33.8325a4.1311,4.1311,0,0,1-1.8379-.4341h0a4.1128,4.1128,0,1,1,1.8379.4341ZM95.6128,32.95a3.64,3.64,0,1,0-1.6416-4.8784A3.6451,3.6451,0,0,0,95.6128,32.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M32.7007,78.6733a4.1308,4.1308,0,0,1-1.8379-.4341h0a4.1132,4.1132,0,1,1,1.8379.4341Zm-1.6153-.8823a3.64,3.64,0,1,0-1.6416-4.8784,3.6081,3.6081,0,0,0,1.6416,4.8784Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M24.8433,23.12a5.2178,5.2178,0,1,1,4.6816-2.897A5.1854,5.1854,0,0,1,24.8433,23.12Zm.0127-9.938a4.7232,4.7232,0,1,0,2.0937.4951A4.727,4.727,0,0,0,24.856,13.1816Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M44.0532,89.4365a5.23,5.23,0,1,1,1.669-.2749A5.2,5.2,0,0,1,44.0532,89.4365Zm.0088-9.9409A4.719,4.719,0,0,0,41.96,88.4414h0a4.7176,4.7176,0,1,0,2.1016-8.9458Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M43.96,68.1338a4.5166,4.5166,0,1,1,1.4415-.2373A4.49,4.49,0,0,1,43.96,68.1338Zm.0118-8.5137a4.0051,4.0051,0,1,0,1.7744.4175A4.0121,4.0121,0,0,0,43.9722,59.62Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 97.0033,
    cy: 8.4953,
    r: 2.8637
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 68.0472,
    cy: 107.2739,
    r: 2.8637
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 86.3436,
    cy: 20.1857,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 107.3781,
    cy: 106.1621,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.7622,5.2231A5.224,5.224,0,0,1,102.5444.0049a5.2178,5.2178,0,1,1,10.4356,0A5.2239,5.2239,0,0,1,107.7622,5.2231Zm0-9.936A4.7229,4.7229,0,0,0,103.0444.0049a4.7233,4.7233,0,0,0,4.7178,4.7182A4.7233,4.7233,0,0,0,112.48.0049,4.7229,4.7229,0,0,0,107.7622-4.7129Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 107.3781,
    cy: -0.5907,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.0093,5.2231A5.2239,5.2239,0,0,1-4.2085.0049,5.2238,5.2238,0,0,1,1.0093-5.2129,5.2238,5.2238,0,0,1,6.227.0049,5.2239,5.2239,0,0,1,1.0093,5.2231Zm0-9.936A4.7229,4.7229,0,0,0-3.7085.0049,4.7233,4.7233,0,0,0,1.0093,4.7231,4.7233,4.7233,0,0,0,5.727.0049,4.7229,4.7229,0,0,0,1.0093-4.7129Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.6254,
    cy: -0.5907,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.0093,111.9756a5.2178,5.2178,0,0,1,0-10.4356,5.2178,5.2178,0,0,1,0,10.4356Zm0-9.9356a4.7178,4.7178,0,0,0,0,9.4356,4.7178,4.7178,0,0,0,0-9.4356Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.6254,
    cy: 106.1621,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 66.0624,
    cy: 20.4537,
    r: 1.9848
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 43.9649,
    cy: 20.0902,
    r: 1.7241
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 34.7014,
    cy: 31.3947,
    r: 2.8992
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 11.5454,
    cy: 29.4763,
    r: 2.3164
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 25.033,
    cy: 17.6063,
    r: 2.4453
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 54.9324,
    cy: 31.3165,
    r: 2.1549
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 75.7075,
    cy: 32.8601,
    r: 2.4651
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M22.7583,109.9858a4.228,4.228,0,1,1,4.2275-4.228A4.2327,4.2327,0,0,1,22.7583,109.9858Zm0-8.206a3.978,3.978,0,1,0,3.9775,3.978A3.983,3.983,0,0,0,22.7583,101.78Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 22.3865,
    cy: 105.7579,
    r: 2.4651
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M22.7583,3.2329A4.2327,4.2327,0,0,1,18.53-.9951a4.2326,4.2326,0,0,1,4.2285-4.2276A4.2323,4.2323,0,0,1,26.9858-.9951,4.2324,4.2324,0,0,1,22.7583,3.2329Zm0-8.2056A3.9827,3.9827,0,0,0,18.78-.9951a3.9831,3.9831,0,0,0,3.9785,3.978,3.9822,3.9822,0,0,0,3.9775-3.978A3.9818,3.9818,0,0,0,22.7583-4.9727Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 22.3865,
    cy: -0.9949,
    r: 2.4651
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 96.8816,
    cy: 29.8601,
    r: 1.8753
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 86.6347,
    cy: 42.1996,
    r: 1.9125
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 108.3499,
    cy: 18.6839,
    r: 1.9125
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 65.1199,
    cy: 42.1996,
    r: 2.418
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 44.0583,
    cy: 42.2554,
    r: 2.8269
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 22.7578,
    cy: 42.0061,
    r: 1.8159
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 12.1337,
    cy: 52.7141,
    r: 2.0095
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 33.7052,
    cy: 53.5635,
    r: 2.6579
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 106.7619,
    cy: 64.0923,
    r: 2.6579
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 55.2704,
    cy: 52.5543,
    r: 2.3023
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 75.7075,
    cy: 51.9553,
    r: 2.4651
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 98.2319,
    cy: 51.3973,
    r: 1.3452
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 85.8764,
    cy: 63.6255,
    r: 2.4114
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 64.7319,
    cy: 64.1524,
    r: 2.2005
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 44.0046,
    cy: 62.1524,
    r: 1.5261
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M85.5259,4.85a4.843,4.843,0,0,1-4.584-3.3,4.8091,4.8091,0,0,1,.2529-3.7A4.8527,4.8527,0,0,1,87.689-4.3345,4.8508,4.8508,0,0,1,89.8726,2.16,4.8516,4.8516,0,0,1,85.5259,4.85ZM83.602,3.8965a4.3511,4.3511,0,0,0,5.8233-1.959,4.35,4.35,0,0,0-1.959-5.8237,4.35,4.35,0,0,0-5.8242,1.9589A4.318,4.318,0,0,0,81.4155,1.39,4.316,4.316,0,0,0,83.602,3.8965Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 85.5338,
    cy: -1.468,
    r: 1.5261
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M85.53,111.605a4.8276,4.8276,0,0,1-2.15-.5078h0a4.814,4.814,0,1,1,2.15.5078Zm.0117-9.1914a4.3439,4.3439,0,0,0-1.9395,8.2353h0a4.3444,4.3444,0,1,0,1.9395-8.2353Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 85.5338,
    cy: 105.2848,
    r: 1.5261
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 22.117,
    cy: 63.7454,
    r: 2.0314
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 11.9812,
    cy: 74.8419,
    r: 2.1619
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 33.1899,
    cy: 74.8419,
    r: 1.9965
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 55.7324,
    cy: 74.0741,
    r: 1.7475
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 75.1294,
    cy: 74.5313,
    r: 1.6797
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 107.4415,
    cy: 39.2039,
    r: 1.6797
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 96.6436,
    cy: 74.8419,
    r: 2.3164
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 106.7619,
    cy: 86.5072,
    r: 2.3164
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-1.0093,91.7251a5.2239,5.2239,0,0,1-5.2178-5.2178A5.224,5.224,0,0,1-1.0093,81.29a5.2239,5.2239,0,0,1,5.2178,5.2178A5.2238,5.2238,0,0,1-1.0093,91.7251Zm0-9.9356a4.723,4.723,0,0,0-4.7178,4.7178,4.723,4.723,0,0,0,4.7178,4.7178,4.7229,4.7229,0,0,0,4.7178-4.7178A4.7229,4.7229,0,0,0-1.0093,81.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.5728,91.3032a5.5469,5.5469,0,1,1,0-11.0937,5.5469,5.5469,0,1,1,0,11.0937Zm0-10.8437a5.2969,5.2969,0,1,0,0,10.5937,5.2969,5.2969,0,1,0,0-10.5937Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.8188,70.17a5.0777,5.0777,0,1,1,0-10.1553,5.0777,5.0777,0,0,1,0,10.1553Zm0-9.9053a4.8277,4.8277,0,1,0,0,9.6553,4.8277,4.8277,0,0,0,0-9.6553Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.0024,43.3432a4.12,4.12,0,0,1-1.8349-.4311h0a4.1461,4.1461,0,0,1-1.8662-5.55A4.1436,4.1436,0,0,1,1.85,35.4961a4.1137,4.1137,0,0,1,2.083,2.3877,4.1126,4.1126,0,0,1-.2168,3.1616A4.1438,4.1438,0,0,1,.0024,43.3432ZM-1.61,42.4639A3.643,3.643,0,0,0,3.269,40.8227a3.6168,3.6168,0,0,0,.19-2.7793,3.6179,3.6179,0,0,0-1.8321-2.0991,3.6423,3.6423,0,0,0-4.8789,1.6406A3.6459,3.6459,0,0,0-1.61,42.4639Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1.5971,
    cy: 18.6839,
    r: 1.9125
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.0091,
    cy: 64.0923,
    r: 2.6579
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.6888,
    cy: 39.2039,
    r: 1.6797
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.0091,
    cy: 86.5072,
    r: 2.3164
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 86.3631,
    cy: 85.5119,
    r: 1.523
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 74.9799,
    cy: 11.6308,
    r: 1.523
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M67.9321,111.7842a4.0264,4.0264,0,1,1,4.0264-4.0264A4.0312,4.0312,0,0,1,67.9321,111.7842Zm0-7.8028a3.7764,3.7764,0,1,0,3.7764,3.7764A3.7807,3.7807,0,0,0,67.9321,103.9814Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 64.7319,
    cy: 85.4129,
    r: 1.8349
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 43.9649,
    cy: 85.4129,
    r: 2.2327
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 68.0472,
    cy: 0.3874,
    r: 2.8637
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M67.9321,4.8974A4.031,4.031,0,0,1,63.9058.8716a4.0264,4.0264,0,1,1,8.0527,0A4.031,4.031,0,0,1,67.9321,4.8974Zm0-7.8022A3.7806,3.7806,0,0,0,64.1558.8716a3.7764,3.7764,0,0,0,7.5527,0A3.7806,3.7806,0,0,0,67.9321-2.9048Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 44.6773,
    cy: 0.0051,
    r: 2.2327
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 33.1899,
    cy: 96.2562,
    r: 1.5727
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 23.2637,
    cy: 86.1317,
    r: 1.9158
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 10.8221,
    cy: 96.6907,
    r: 2.0096
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 54.9334,
    cy: 96.3375,
    r: 2.5465
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 75.0787,
    cy: 95.586,
    r: 1.5598
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 96.6436,
    cy: 96.3375,
    r: 2.3164
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M55.27,49.74a.25.25,0,0,1-.25-.25V44.6177a.25.25,0,0,1,.5,0V49.49A.25.25,0,0,1,55.27,49.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M57.0874,50.1343a.25.25,0,0,1-.2119-.3833l1.33-2.1084a.25.25,0,0,1,.4238.2666l-1.33,2.1084A.25.25,0,0,1,57.0874,50.1343Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M58.2124,51.3633a.1249.1249,0,0,1-.0371-.2442l5.6191-1.7719a.1283.1283,0,0,1,.1563.0815.1247.1247,0,0,1-.082.1567L58.25,51.3574A.1181.1181,0,0,1,58.2124,51.3633Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M62.3921,53.9145a.2739.2739,0,0,1-.0332-.0019l-4.0567-.5391a.2507.2507,0,0,1-.2148-.2807.2434.2434,0,0,1,.2813-.2154l4.0566.5391a.25.25,0,0,1-.0332.498Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M57.5728,60.7515a.1248.1248,0,0,1-.12-.0918L56.0142,55.415a.1246.1246,0,1,1,.24-.0664l1.4385,5.2446a.1249.1249,0,0,1-.0869.1539A.1312.1312,0,0,1,57.5728,60.7515Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M58.9956,56.8628a.248.248,0,0,1-.1865-.084l-1.4229-1.6a.25.25,0,1,1,.3731-.332l1.4228,1.6a.25.25,0,0,1-.1865.416Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M53.9868,59.0884a.2713.2713,0,0,1-.0439-.0039.25.25,0,0,1-.2022-.29l.585-3.2925a.2471.2471,0,0,1,.29-.2021.25.25,0,0,1,.2022.29l-.585,3.2925A.25.25,0,0,1,53.9868,59.0884Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M51.5249,56.1225a.1231.1231,0,0,1-.0908-.04.125.125,0,0,1,.0049-.1768l1.4433-1.354a.1254.1254,0,0,1,.1719.1826l-1.4434,1.3541A.1275.1275,0,0,1,51.5249,56.1225Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M47.4321,53.5625a.125.125,0,0,1-.0166-.249l4.6709-.6314a.1252.1252,0,0,1,.0332.2481l-4.6709.6313Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M52.2466,50.9956a.2489.2489,0,0,1-.1309-.0371l-2.0351-1.2554a.25.25,0,1,1,.2617-.4258l2.0351,1.2554a.25.25,0,0,1-.1308.4629Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M53.5767,49.8862a.1241.1241,0,0,1-.1133-.0727l-1.56-3.4029a.1248.1248,0,1,1,.2266-.1045l1.56,3.4029a.1242.1242,0,0,1-.0615.166A.1208.1208,0,0,1,53.5767,49.8862Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M30.5513,31.3784l-.0264-.0015-7.1475-.7627a.25.25,0,1,1,.0528-.497l7.1474.7627a.25.25,0,0,1-.0263.4985Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M31.52,28.9648a.25.25,0,0,1-.14-.0425l-3.3985-2.2875a.25.25,0,0,1,.2793-.4151L31.66,28.5073a.25.25,0,0,1-.14.4575Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M33.5835,27.9267a.1254.1254,0,0,1-.1231-.104L32.227,20.6172a.125.125,0,0,1,.1016-.1441.12.12,0,0,1,.1445.1021l1.2334,7.2055a.1248.1248,0,0,1-.1015.1441Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M36.1645,28.2729a.2475.2475,0,0,1-.0673-.0092.2506.2506,0,0,1-.1739-.3081l1.3477-4.82a.25.25,0,0,1,.4824.1348l-1.3476,4.82A.2511.2511,0,0,1,36.1645,28.2729Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M38.2085,29.7412a.125.125,0,0,1-.0381-.2441L42.94,27.96a.1271.1271,0,0,1,.1573.0805.1249.1249,0,0,1-.0811.1577l-4.77,1.5376A.1293.1293,0,0,1,38.2085,29.7412Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M45.689,34.3955a.2435.2435,0,0,1-.0528-.0059l-7.3984-1.6079a.2492.2492,0,0,1-.1914-.2973.2521.2521,0,0,1,.2969-.191l7.3984,1.608a.25.25,0,0,1-.0527.4941Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M39.2661,37.5693a.2475.2475,0,0,1-.2109-.1162l-1.917-3.0283a.25.25,0,1,1,.4219-.2676l1.9169,3.0283a.25.25,0,0,1-.0771.3452A.2537.2537,0,0,1,39.2661,37.5693Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M35.6714,40.8545a.1248.1248,0,0,1-.1231-.105l-.8593-5.36a.1245.1245,0,0,1,.1035-.1435.1284.1284,0,0,1,.1426.1035l.8593,5.36a.1245.1245,0,0,1-.1035.1435Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M30.561,40.9848a.25.25,0,0,1-.2334-.3383L32.4907,34.92a.252.252,0,0,1,.3213-.1455.2494.2494,0,0,1,.1455.3223l-2.1631,5.7265A.249.249,0,0,1,30.561,40.9848Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M28.7915,34.8266a.125.125,0,0,1-.0586-.2353l2.0879-1.1128a.1249.1249,0,0,1,.1172.2207L28.85,34.812A.1268.1268,0,0,1,28.7915,34.8266Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M88.5474,39.9136a.1248.1248,0,0,1-.0948-.2066l3.1153-3.6138a.125.125,0,1,1,.1894.1631L88.6421,39.87A.1239.1239,0,0,1,88.5474,39.9136Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M90.1323,41.4639a.25.25,0,0,1-.0293-.4986l2.8614-.3354a.2589.2589,0,0,1,.2773.2192.25.25,0,0,1-.2188.2778l-2.8613.3355Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M94.8989,43.9438l-.0166-.0009-5.12-.6841a.1256.1256,0,0,1-.1074-.1406.1238.1238,0,0,1,.1406-.1075l5.12.6841a.125.125,0,0,1-.0166.249Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M90.6489,46.2617a.1261.1261,0,0,1-.084-.0322L88.66,44.5185a.1251.1251,0,0,1,.1679-.1855l1.9053,1.7109a.1252.1252,0,0,1-.084.2178Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M88.3589,51.2041a.25.25,0,0,1-.2451-.1992l-1.1407-5.5166a.2508.2508,0,0,1,.1944-.2954.2458.2458,0,0,1,.2959.1938l1.1406,5.5166a.2508.2508,0,0,1-.1943.2954A.2312.2312,0,0,1,88.3589,51.2041Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M81.6675,46.88a.25.25,0,0,1-.169-.4346L84.17,44.0039a.25.25,0,0,1,.3379.3691l-2.6719,2.4414A.2483.2483,0,0,1,81.6675,46.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M77.0854,44.2988a.25.25,0,0,1-.0419-.4966L83.644,42.666a.25.25,0,0,1,.084.4932l-6.6006,1.1362A.247.247,0,0,1,77.0854,44.2988Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M83.2769,41.2187l-.0254-.0024L78.95,40.3315a.1245.1245,0,0,1-.0967-.1479.1224.1224,0,0,1,.1475-.0972l4.3017.8848a.1251.1251,0,0,1-.0253.2475Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M84.7632,39.89a.1239.1239,0,0,1-.0977-.0469L81.8511,36.314a.1251.1251,0,0,1,.1953-.1563l2.8144,3.5293a.1249.1249,0,0,1-.0976.2031Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M86.6343,38.6269a.25.25,0,0,1-.25-.25V32.2222a.25.25,0,0,1,.5,0v6.1547A.25.25,0,0,1,86.6343,38.6269Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M84.9976,47.084a.1257.1257,0,0,1-.1182-.167l.5976-1.6778a.1254.1254,0,0,1,.2364.084l-.5977,1.6778A.1253.1253,0,0,1,84.9976,47.084Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M19.4214,62.3862a.1216.1216,0,0,1-.0645-.018l-4.083-2.4693a.1249.1249,0,1,1,.1289-.2139l4.083,2.4693a.1249.1249,0,0,1,.043.1714A.1268.1268,0,0,1,19.4214,62.3862Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M20.562,60.7109a.2505.2505,0,0,1-.24-.18l-.8067-2.7651a.25.25,0,1,1,.48-.14l.8066,2.7651a.2513.2513,0,0,1-.17.31A.27.27,0,0,1,20.562,60.7109Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M22.5151,60.6142a.1248.1248,0,0,1-.125-.1206l-.1787-5.1621a.1259.1259,0,0,1,.1211-.1294.1217.1217,0,0,1,.1289.1206l.1787,5.1621a.1256.1256,0,0,1-.1211.1294Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M23.96,61.5454a.2534.2534,0,0,1-.1337-.0386.25.25,0,0,1-.0772-.3452l1.37-2.1641a.25.25,0,1,1,.4219.2676l-1.37,2.1641A.2477.2477,0,0,1,23.96,61.5454Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M25.2124,62.7558a.1251.1251,0,0,1-.0449-.2417l5.249-2.0439a.125.125,0,0,1,.09.2334l-5.249,2.0439A.1318.1318,0,0,1,25.2124,62.7558Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M27.313,68.1553a.2484.2484,0,0,1-.1543-.0533l-2.8525-2.2285a.25.25,0,1,1,.3085-.3935l2.8526,2.2285a.25.25,0,0,1-.1543.4468Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M25.5308,73.103a.2506.2506,0,0,1-.2364-.167l-2.22-6.3193a.2505.2505,0,0,1,.4727-.166l2.22,6.3193a.25.25,0,0,1-.2363.333Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21.43,71.7539h-.0049a.1255.1255,0,0,1-.12-.1294l.1552-4.3887a.1254.1254,0,0,1,.125-.1206H21.59a.1256.1256,0,0,1,.12.1294l-.1552,4.3887A.1254.1254,0,0,1,21.43,71.7539Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M17.0171,69.6094a.25.25,0,0,1-.1865-.417L19.8423,65.83a.25.25,0,0,1,.373.334l-3.0117,3.3628A.2527.2527,0,0,1,17.0171,69.6094Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.2788,65.5327a.1249.1249,0,0,1-.0205-.248l6.0684-1.0254a.1247.1247,0,1,1,.041.2461l-6.0684,1.0253Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M27.0825,64.8164a.2225.2225,0,0,1-.043-.0039l-1.7539-.3091a.2491.2491,0,0,1-.2031-.29.2461.2461,0,0,1,.2891-.2027l1.7539.3091a.25.25,0,0,1-.043.4961Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M98.96,72.7754a.25.25,0,0,1-.14-.4575l2.9434-1.9756a.25.25,0,1,1,.2793.415L99.1,72.7329A.2506.2506,0,0,1,98.96,72.7754Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M97.4868,71.7876a.2671.2671,0,0,1-.0586-.0069.25.25,0,0,1-.1845-.3017l1.4736-6.12a.2547.2547,0,0,1,.3017-.1846.2506.2506,0,0,1,.1846.3018l-1.4736,6.12A.25.25,0,0,1,97.4868,71.7876Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M95.3481,71.6626a.1258.1258,0,0,1-.122-.0972l-.7774-3.3994a.1256.1256,0,0,1,.0938-.15.1242.1242,0,0,1,.15.0942l.7773,3.4a.1257.1257,0,0,1-.0937.15A.1521.1521,0,0,1,95.3481,71.6626Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M94.0073,72.65a.1257.1257,0,0,1-.0888-.0371l-3.3633-3.419a.125.125,0,0,1,.1777-.1758l3.3633,3.419a.1251.1251,0,0,1-.0889.2129Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M93.5229,74.5586a.2419.2419,0,0,1-.0322-.002l-3.2822-.42a.25.25,0,0,1-.2158-.28.2451.2451,0,0,1,.28-.2163l3.2823.42a.25.25,0,0,1-.0323.4981Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M88.2876,77.5181a.125.125,0,0,1-.0264-.2471l5.4112-1.1821a.1273.1273,0,0,1,.1484.0952.1254.1254,0,0,1-.0957.1489L88.314,77.5151A.1188.1188,0,0,1,88.2876,77.5181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M93.5513,79.5459a.2473.2473,0,0,1-.1465-.0474.2506.2506,0,0,1-.0567-.3491l1.2862-1.7808a.25.25,0,0,1,.4062.293l-1.2861,1.7808A.2526.2526,0,0,1,93.5513,79.5459Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M95.8862,83.7031l-.0088-.0005a.1247.1247,0,0,1-.1162-.1328l.3789-5.5742a.13.13,0,0,1,.1338-.1162.1246.1246,0,0,1,.1162.1328l-.3789,5.5742A.1257.1257,0,0,1,95.8862,83.7031Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M99.4419,79.72a.25.25,0,0,1-.2012-.1016L98.022,77.9692a.25.25,0,0,1,.0527-.35.2527.2527,0,0,1,.35.0527l1.2188,1.6495a.25.25,0,0,1-.2012.3984Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M102.6187,77.7622a.1208.1208,0,0,1-.0547-.0127l-2.9327-1.4263a.1249.1249,0,1,1,.1094-.2246l2.9326,1.4263a.1249.1249,0,0,1-.0546.2373Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M100.1138,74.4624a.1248.1248,0,0,1-.0176-.2485l6.1885-.8985a.1211.1211,0,0,1,.1416.1055.1255.1255,0,0,1-.1065.1416l-6.1885.8984Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M64.0308,82.6465a.25.25,0,0,1-.2442-.1973l-1.1338-5.2383a.25.25,0,1,1,.4883-.1054l1.1338,5.2382a.25.25,0,0,1-.1914.2969A.2433.2433,0,0,1,64.0308,82.6465Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M65.7368,82.7832a.2465.2465,0,0,1-.1074-.0244.2493.2493,0,0,1-.1182-.333l.83-1.7422a.252.252,0,0,1,.333-.1182.2493.2493,0,0,1,.1182.333l-.83,1.7422A.2506.2506,0,0,1,65.7368,82.7832Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M66.9321,84.1138a.1252.1252,0,0,1-.0537-.2383l3.5293-1.6612a.1254.1254,0,0,1,.1074.2266L66.9858,84.102A.1333.1333,0,0,1,66.9321,84.1138Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M73.2427,86.3442l-.0147-.0005-5.6572-.3379a.2509.2509,0,0,1-.2354-.2646.2416.2416,0,0,1,.2647-.2344l5.6572.3379a.25.25,0,0,1-.0146.4995Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M67.27,89.584a.2493.2493,0,0,1-.208-.1118l-1.1182-1.6885a.25.25,0,1,1,.4161-.2764l1.1181,1.6885a.25.25,0,0,1-.208.3882Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M63.4644,92.0708l-.0176-.0015a.1247.1247,0,0,1-.1065-.1411l.5664-4.0024a.1217.1217,0,0,1,.1416-.106.1248.1248,0,0,1,.1065.1411l-.5664,4.0025A.1251.1251,0,0,1,63.4644,92.0708Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M59.9155,87.8955a.25.25,0,0,1-.126-.4658l1.9512-1.1382a.25.25,0,0,1,.252.4316l-1.9512,1.1382A.2465.2465,0,0,1,59.9155,87.8955Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M61.8667,85.07l-.0088-.0005-5.8828-.4258a.1248.1248,0,0,1-.1162-.1333.1283.1283,0,0,1,.1338-.1157l5.8828.4258a.1249.1249,0,0,1-.0088.2495Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M62.5317,83.2832a.1248.1248,0,0,1-.0849-.0332L61.022,81.9355a.1251.1251,0,1,1,.17-.1836l1.4248,1.3145a.125.125,0,0,1-.085.2168Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M50.9985,3.8174a.121.121,0,0,1-.0586-.0147L47.4272,1.9512a.1249.1249,0,0,1,.1172-.2207L51.0571,3.582a.1251.1251,0,0,1-.0586.2354Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M47.063,5.2451a.2481.2481,0,0,1-.2276-.1475L45.92,3.0625a.25.25,0,1,1,.4551-.2051l.915,2.0352a.25.25,0,0,1-.125.33A.2458.2458,0,0,1,47.063,5.2451Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M43.0483,7.4263a.1457.1457,0,0,1-.0254-.0025.1245.1245,0,0,1-.0966-.1484L43.811,3.07a.1313.1313,0,0,1,.1475-.0967.1247.1247,0,0,1,.0967.1485L43.17,7.3271A.1247.1247,0,0,1,43.0483,7.4263Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M40.6128,4.6763a.1249.1249,0,0,1-.0986-.2017l1.6279-2.106a.123.123,0,0,1,.1748-.0224.1249.1249,0,0,1,.0225.1758l-1.628,2.1059A.1242.1242,0,0,1,40.6128,4.6763Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M38.4106,2.46a.25.25,0,0,1-.1035-.4776L41.4478.5493a.25.25,0,0,1,.207.4551L38.5142,2.437A.25.25,0,0,1,38.4106,2.46Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 44.6773,
    cy: 106.7579,
    r: 2.2327
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M41.7085,105.5215a.1211.1211,0,0,1-.0547-.0127l-4.0889-1.99a.1249.1249,0,1,1,.1094-.2246l4.0889,1.99a.125.125,0,0,1-.0547.2373Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M43.0278,104.4512a.2493.2493,0,0,1-.205-.1075l-1.6563-2.3818a.25.25,0,0,1,.41-.2852l1.6562,2.3819a.2493.2493,0,0,1-.0625.3476A.2466.2466,0,0,1,43.0278,104.4512Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M44.7319,103.8076l-.0273-.0015a.25.25,0,0,1-.2207-.2758l.6689-6.0957a.2419.2419,0,0,1,.2754-.2212.25.25,0,0,1,.2207.2758l-.6689,6.0957A.25.25,0,0,1,44.7319,103.8076Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M46.688,104.626a.1251.1251,0,0,1-.1026-.1963l2.4034-3.4683a.1237.1237,0,0,1,.1738-.0312.125.125,0,0,1,.0312.1738l-2.4033,3.4683A.1249.1249,0,0,1,46.688,104.626Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M75.6167,9.0088l-.0225-.002a.1247.1247,0,0,1-.1-.145l.8857-4.9062a.12.12,0,0,1,.1455-.1011A.1247.1247,0,0,1,76.6255,4L75.74,8.9057A.1249.1249,0,0,1,75.6167,9.0088Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M77.352,10.0381a.25.25,0,0,1-.1572-.4444l2.3125-1.8715a.25.25,0,1,1,.3145.3886L77.5093,9.9824A.247.247,0,0,1,77.352,10.0381Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M83.4409,11.7558H77.78a.125.125,0,0,1,0-.25h5.6611a.125.125,0,0,1,0,.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M78.314,14.6182a.1244.1244,0,0,1-.0762-.0259l-1.39-1.0635a.125.125,0,1,1,.1524-.1982l1.39,1.0634a.1251.1251,0,0,1,.0235.1753A.128.128,0,0,1,78.314,14.6182Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M76.105,18.9341a.25.25,0,0,1-.2471-.2139L75.18,14.0537a.25.25,0,1,1,.4941-.0723l.6777,4.6665a.2493.2493,0,0,1-.2109.2837A.3059.3059,0,0,1,76.105,18.9341Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M72.2905,16.2163a.123.123,0,0,1-.0595-.0151.1253.1253,0,0,1-.05-.17l1.166-2.13a.1248.1248,0,1,1,.2187.12l-1.166,2.13A.1243.1243,0,0,1,72.2905,16.2163Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M68.0474,14.2114a.25.25,0,0,1-.0811-.4863l4.4785-1.5391a.25.25,0,0,1,.1621.4727l-4.4785,1.539A.2431.2431,0,0,1,68.0474,14.2114Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M71.8335,10.8374A.1306.1306,0,0,1,71.8,10.833l-2.1787-.6045a.1251.1251,0,0,1,.0664-.2412l2.1787.6045a.1251.1251,0,0,1-.0332.2456Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M73.3374,9.5981a.25.25,0,0,1-.2207-.1328l-1.624-3.06a.25.25,0,0,1,.4414-.2344l1.624,3.06a.25.25,0,0,1-.1035.3379A.2445.2445,0,0,1,73.3374,9.5981Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M102.7017,22.8662a.25.25,0,0,1-.1377-.459l3.3681-2.2182a.25.25,0,1,1,.2754.4179l-3.3681,2.2183A.2508.2508,0,0,1,102.7017,22.8662Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M98.1938,19.563a.25.25,0,0,1-.0214-.499l7.44-.629a.2381.2381,0,0,1,.2705.2281.25.25,0,0,1-.2275.27l-7.44.6289Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M105.7856,17.2046a.1207.1207,0,0,1-.0546-.0127l-1.8165-.8819a.1251.1251,0,0,1-.0576-.1669.1266.1266,0,0,1,.167-.0577l1.8164.8819a.125.125,0,0,1-.0547.2373Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M106.7622,16.4477a.2486.2486,0,0,1-.2246-.1411l-1.5049-3.1128a.25.25,0,1,1,.4492-.2177l1.5049,3.1128a.2489.2489,0,0,1-.1162.3339A.2414.2414,0,0,1,106.7622,16.4477Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.5972,16.2544a.25.25,0,0,1-.25-.25V10.9805a.25.25,0,0,1,.5,0v5.0239A.25.25,0,0,1,1.5972,16.2544Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.2124,16.5107a.123.123,0,0,1-.0762-.0263.125.125,0,0,1-.0224-.1753l1.4736-1.8985a.125.125,0,0,1,.1973.1534L3.311,16.4624A.1243.1243,0,0,1,3.2124,16.5107Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.9,17.87a.1248.1248,0,0,1-.0322-.2456l6.4375-1.74a.1281.1281,0,0,1,.1533.0879.1252.1252,0,0,1-.0889.1533l-6.4375,1.74A.119.119,0,0,1,3.9,17.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8,20.5757a.2772.2772,0,0,1-.0527-.0054l-3.9815-.8555a.25.25,0,0,1-.1914-.2973.2558.2558,0,0,1,.2969-.1919l3.9814.8554A.25.25,0,0,1,8,20.5757Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.7661,25.4458a.2475.2475,0,0,1-.206-.1089L2.8384,21.3515a.25.25,0,1,1,.4121-.2822l2.7217,3.9854a.25.25,0,0,1-.2061.3911Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.396,23.749a.1253.1253,0,0,1-.1221-.1514l.5244-2.4331a.1249.1249,0,0,1,.2442.0528L.5181,23.65A.1251.1251,0,0,1,.396,23.749Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.8188,94.041a.25.25,0,0,1-.2392-.1768l-.71-2.3159a.25.25,0,1,1,.4785-.1465l.71,2.316a.2511.2511,0,0,1-.166.3125A.254.254,0,0,1,9.8188,94.041Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.5454,93.916l-.0215-.002a.1248.1248,0,0,1-.1015-.145l1.2861-7.2837a.1214.1214,0,0,1,.1445-.101.1249.1249,0,0,1,.1016.145L11.6685,93.813A.1251.1251,0,0,1,11.5454,93.916Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.8315,94.499a.1254.1254,0,0,1-.0878-.2143l2.4814-2.4283a.1253.1253,0,0,1,.1758.1787l-2.4815,2.4283A.1258.1258,0,0,1,12.8315,94.499Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.6528,96.5063a.25.25,0,0,1-.0341-.4975l6.2685-.8584a.2458.2458,0,0,1,.2822.2138.25.25,0,0,1-.2138.2813l-6.2686.8584A.2735.2735,0,0,1,13.6528,96.5063Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M16.7876,98.6562a.2448.2448,0,0,1-.0459-.0044l-3.07-.5771a.2505.2505,0,0,1-.2-.292.246.246,0,0,1,.292-.1992l3.07.5771a.25.25,0,0,1-.0459.4956Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.0728,103.3843a.1233.1233,0,0,1-.1084-.0635L11.8726,99.62a.1246.1246,0,1,1,.2168-.123l2.0918,3.7011a.1247.1247,0,0,1-.0469.1705A.1293.1293,0,0,1,14.0728,103.3843Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.8188,104.9282l-.0283-.0015a.25.25,0,0,1-.22-.2773l.57-4.9282a.2547.2547,0,0,1,.2764-.22.25.25,0,0,1,.22.2773l-.57,4.9282A.2493.2493,0,0,1,9.8188,104.9282Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6.8384,100.6348a.1249.1249,0,0,1-.0791-.2217l1.9746-1.626a.1249.1249,0,1,1,.1582.1934l-1.9746,1.6259A.1218.1218,0,0,1,6.8384,100.6348Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.3257,97.312a.25.25,0,0,1-.002-.5l5.6875-.05a.2534.2534,0,0,1,.252.248.25.25,0,0,1-.2481.252l-5.6875.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.2134,95.2a.2474.2474,0,0,1-.1338-.0391l-2.8164-1.79a.25.25,0,1,1,.2676-.4219l2.8164,1.79a.25.25,0,0,1-.1338.461Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.01,111.9756a5.2178,5.2178,0,0,1,0-10.4356,5.2178,5.2178,0,0,1,0,10.4356Zm0-9.9356a4.7178,4.7178,0,0,0,0,9.4356,4.7178,4.7178,0,0,0,0-9.4356Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-1.0091,91.7251a5.2238,5.2238,0,0,1-5.2178-5.2178A5.2239,5.2239,0,0,1-1.0091,81.29a5.224,5.224,0,0,1,5.2178,5.2178A5.2239,5.2239,0,0,1-1.0091,91.7251Zm0-9.9356a4.7229,4.7229,0,0,0-4.7178,4.7178,4.7229,4.7229,0,0,0,4.7178,4.7178,4.7229,4.7229,0,0,0,4.7178-4.7178A4.7229,4.7229,0,0,0-1.0091,81.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.5729,91.3032a5.5469,5.5469,0,0,1,0-11.0937,5.5469,5.5469,0,1,1,0,11.0937Zm0-10.8437a5.2969,5.2969,0,0,0,0,10.5937,5.2969,5.2969,0,1,0,0-10.5937Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.818,70.2949a5.2027,5.2027,0,0,1,0-10.4053,5.2027,5.2027,0,1,1,0,10.4053Zm0-9.9053a4.7027,4.7027,0,0,0,0,9.4053,4.7027,4.7027,0,1,0,0-9.4053Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.0046,43.3457a4.1261,4.1261,0,0,1-1.8369-.4336h0a4.1462,4.1462,0,0,1-1.8663-5.55A4.1435,4.1435,0,0,1,1.85,35.4961a4.1171,4.1171,0,0,1,2.083,2.3877,4.1126,4.1126,0,0,1-.2168,3.1616,4.1079,4.1079,0,0,1-2.3877,2.082A4.1451,4.1451,0,0,1,.0046,43.3457ZM-1.61,42.4639a3.6238,3.6238,0,0,0,2.7793.19,3.6166,3.6166,0,0,0,2.1-1.8311,3.6127,3.6127,0,0,0,.1895-2.7793,3.6129,3.6129,0,0,0-1.8311-2.0991,3.6423,3.6423,0,0,0-4.8789,1.6406A3.6458,3.6458,0,0,0-1.61,42.4639Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.6254,
    cy: 106.1621,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.01,5.2231A5.2239,5.2239,0,0,1-4.2083.0049,5.2238,5.2238,0,0,1,1.01-5.2129,5.2238,5.2238,0,0,1,6.2272.0049,5.2239,5.2239,0,0,1,1.01,5.2231Zm0-9.936A4.7229,4.7229,0,0,0-3.7083.0049,4.7233,4.7233,0,0,0,1.01,4.7231,4.7233,4.7233,0,0,0,5.7272.0049,4.7229,4.7229,0,0,0,1.01-4.7129Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.6254,
    cy: -0.5907,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1.5971,
    cy: 18.6839,
    r: 1.9125
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.0091,
    cy: 64.0923,
    r: 2.6579
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.6888,
    cy: 39.2039,
    r: 1.6797
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.0091,
    cy: 86.5072,
    r: 2.3164
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.01,16.4477a.2487.2487,0,0,1-.2247-.1411L-1.72,13.1938a.249.249,0,0,1,.1162-.334.25.25,0,0,1,.333.1163L.2341,16.0889a.249.249,0,0,1-.1163.3339A.2407.2407,0,0,1,.01,16.4477Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.762,5.2228A5.2238,5.2238,0,0,1,102.5443.005a5.2178,5.2178,0,0,1,10.4355,0A5.2238,5.2238,0,0,1,107.762,5.2228Zm0-9.9355A4.7228,4.7228,0,0,0,103.0443.005a4.7229,4.7229,0,0,0,4.7177,4.7178A4.7229,4.7229,0,0,0,112.48.005,4.7229,4.7229,0,0,0,107.762-4.7127Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 107.3781,
    cy: -0.5907,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.7622,5.2228A5.2239,5.2239,0,0,1,102.5444.005a5.2178,5.2178,0,0,1,10.4356,0A5.2238,5.2238,0,0,1,107.7622,5.2228Zm0-9.9355A4.7229,4.7229,0,0,0,103.0444.005a4.7229,4.7229,0,0,0,4.7178,4.7178A4.7229,4.7229,0,0,0,112.48.005,4.7229,4.7229,0,0,0,107.7622-4.7127Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 68.0472,
    cy: 0.5211,
    r: 2.8637
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 107.3781,
    cy: -0.5907,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.0093,5.2228A5.2238,5.2238,0,0,1-4.2085.005,5.2238,5.2238,0,0,1,1.0093-5.2127,5.2238,5.2238,0,0,1,6.227.005,5.2238,5.2238,0,0,1,1.0093,5.2228Zm0-9.9355A4.7229,4.7229,0,0,0-3.7085.005,4.7229,4.7229,0,0,0,1.0093,4.7228,4.7229,4.7229,0,0,0,5.727.005,4.7228,4.7228,0,0,0,1.0093-4.7127Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.6254,
    cy: -0.5907,
    r: 2.9027
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M22.7583,3.2331A4.2327,4.2327,0,0,1,18.53-.995a4.2327,4.2327,0,0,1,4.2285-4.228A4.2324,4.2324,0,0,1,26.9858-.995,4.2324,4.2324,0,0,1,22.7583,3.2331Zm0-8.2061A3.9831,3.9831,0,0,0,18.78-.995a3.9831,3.9831,0,0,0,3.9785,3.9781A3.9823,3.9823,0,0,0,26.7358-.995,3.9822,3.9822,0,0,0,22.7583-4.973Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 22.3865,
    cy: -0.9949,
    r: 2.4651
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M85.53,4.8522a4.8276,4.8276,0,0,1-2.15-.5078h0A4.8117,4.8117,0,0,1,80.9419,1.55a4.8091,4.8091,0,0,1,.2529-3.7A4.8524,4.8524,0,0,1,87.689-4.3343a4.811,4.811,0,0,1,2.4365,2.7949A4.8079,4.8079,0,0,1,89.8726,2.16a4.81,4.81,0,0,1-2.794,2.437A4.8436,4.8436,0,0,1,85.53,4.8522Zm.0117-9.1914a4.3514,4.3514,0,0,0-3.8994,2.4121A4.318,4.318,0,0,0,81.4155,1.39,4.3139,4.3139,0,0,0,83.602,3.8962h0a4.3107,4.3107,0,0,0,3.3165.227,4.3179,4.3179,0,0,0,2.5068-2.186A4.3177,4.3177,0,0,0,89.6519-1.38a4.3158,4.3158,0,0,0-2.1856-2.5059A4.314,4.314,0,0,0,85.5415-4.3392Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 85.5338,
    cy: -1.468,
    r: 1.5261
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M67.9321,5.0314A4.0264,4.0264,0,1,1,71.9585,1.005,4.0311,4.0311,0,0,1,67.9321,5.0314Zm0-7.8027A3.7764,3.7764,0,1,0,71.7085,1.005,3.7806,3.7806,0,0,0,67.9321-2.7713Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 44.6773,
    cy: 0.0051,
    r: 2.2327
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.01,5.2228A5.2238,5.2238,0,0,1-4.2083.005,5.2238,5.2238,0,0,1,1.01-5.2127,5.2238,5.2238,0,0,1,6.2272.005,5.2238,5.2238,0,0,1,1.01,5.2228Zm0-9.9355A4.7229,4.7229,0,0,0-3.7083.005,4.7229,4.7229,0,0,0,1.01,4.7228,4.7229,4.7229,0,0,0,5.7272.005,4.7228,4.7228,0,0,0,1.01-4.7127Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.6254,
    cy: -0.5907,
    r: 2.9027
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M121.5,98.0463s19.882-30.4249,0-65.0838C101.7491-1.4672,65.1356.4207,65.1356.4207V65.5044Z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "g",
    width: 186.6614,
    height: 106.7528,
    patternTransform: "translate(-175.2664 295.7743) scale(1.12)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 186.661 106.753"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 186.6614,
    height: 106.7528
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M186.8107,105.2779c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M79.8468,105.2779c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M.1492,105.2779c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-106.8146,105.2779c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M186.8107-1.4749c3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.344,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.4788-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M186.8107,3.162c3.4193,0,9.9248,3.0536,13.3441,3.0536S210.08,3.162,213.4989,3.162s9.9248,3.0536,13.344,3.0536S236.7677,3.162,240.187,3.162s9.9248,3.0536,13.3441,3.0536S263.01,3.162,266.8752,3.162"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M186.8107,12.434c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M186.8107,105.174c3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.344,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.4788-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M186.8107,17.0728c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M186.8107,21.71c3.4193,0,9.9248,3.0535,13.3441,3.0535S210.08,21.71,213.4989,21.71s9.9248,3.0535,13.344,3.0535S236.7677,21.71,240.187,21.71s9.9248,3.0535,13.3441,3.0535S263.01,21.71,266.8752,21.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M186.8107,26.3466c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535S223.4237,29.4,226.8429,29.4s9.9248-3.0535,13.3441-3.0535S250.1118,29.4,253.5311,29.4s9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M186.8107,8.1079a35.8009,35.8009,0,0,1,8.4963,1.6738"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M186.8107,40.2573c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M186.8466,35.5114c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535c2.348,0,5.1533.9259,8.4131,1.8281"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M186.8466,95.9c3.4193,0,9.9248,3.0535,13.3441,3.0535S210.1155,95.9,213.5348,95.9s9.9248,3.0535,13.3441,3.0535S236.8037,95.9,240.223,95.9c2.348,0,5.1533.9259,8.4131,1.8282"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M186.8107,30.5533c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M186.8107,44.8942c3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.344,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.4788-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M186.7834,49.5311c3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.4787-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M186.75,54.168c3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.4787-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M186.8107,68.0788c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535c2.4919,0,5.0018,1.1764,8.3829,2.0562"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M186.8107,63.4419c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M186.7835,59.1683c3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.344-3.0536,9.9249,3.0536,13.3441,3.0536,9.4788-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M186.8107,77.3526c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M186.8107,72.7157c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M186.8107,86.6264c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M186.8107,81.99c3.4193,0,9.9248,3.0535,13.3441,3.0535S210.08,81.99,213.4989,81.99s9.9248,3.0535,13.344,3.0535S236.7677,81.99,240.187,81.99s9.9248,3.0535,13.3441,3.0535S263.01,81.99,266.8752,81.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M186.8107,100.846c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M186.8107,91.2652c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M186.8107,95.9325a35.8016,35.8016,0,0,1,8.4963,1.6739"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M79.8468-1.4749c3.25,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536S182.7342-1.4749,186.6-1.4749"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M79.8468,3.162c3.25,0,9.9248,3.0536,13.3441,3.0536S103.1157,3.162,106.535,3.162s9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536S182.7342,3.162,186.6,3.162"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M79.8468,12.434c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535S182.7342,12.434,186.6,12.434"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M79.8468,105.174c3.25,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.4787-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M79.8468,17.0728c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M79.8468,8.1079c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535S182.7342,8.1079,186.6,8.1079"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M79.8468,26.3466c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535S116.46,29.4,119.8791,29.4s9.9248-3.0535,13.3441-3.0535S143.148,29.4,146.5673,29.4s9.9248-3.0535,13.3441-3.0535S169.8362,29.4,173.2555,29.4s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M79.8468,35.72c3.25,0,9.9248,3.0536,13.3441,3.0536S103.1157,35.72,106.535,35.72s9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536S182.7342,35.72,186.6,35.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M177.9619,46.972c3.2224-.8936,5.8985-1.7533,8.6377-1.7533"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M79.8468,45.01c3.25,0,9.9248,3.0536,13.3441,3.0536S103.1157,45.01,106.535,45.01s9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536c2.3479,0,5.1533.9259,8.4131,1.8282"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M79.8468,40.2573c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M79.8468,30.5533c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M98.223,55.8681c3.338-.8912,5.8476-1.7,8.2848-1.7,3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.4787-3.0536,13.344-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M79.82,54.168c2.1968,0,4.6971.8519,7.96,1.7561"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M79.7865,49.5311c3.25,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.344,3.0536,9.4788-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M151.7094,69.9205c3.4654-.8393,5.5849-1.8417,8.202-1.8417,3.4193,0,9.9248,3.0535,13.3441,3.0535s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M79.8468,68.0788c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535c2.4919,0,5.0019,1.1764,8.383,2.0562"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M151.7094,23.4241c3.4654-.8394,5.5849-1.8418,8.202-1.8418,3.4193,0,9.9248,3.0535,13.3441,3.0535s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M79.8468,21.5823c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535c2.4919,0,5.0019,1.1765,8.383,2.0562"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M79.8468,63.4419c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M79.82,59.1683c3.25,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.4787-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M79.8468,77.3526c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M79.8468,72.7157c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M79.8468,86.6264c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535S116.46,89.68,119.8791,89.68s9.9248-3.0535,13.3441-3.0535S143.148,89.68,146.5673,89.68s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M79.8468,81.99c3.25,0,9.9248,3.0535,13.3441,3.0535S103.1157,81.99,106.535,81.99s9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535S182.7342,81.99,186.6,81.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M79.8468,95.9c3.25,0,9.9248,3.0535,13.3441,3.0535S103.1157,95.9,106.535,95.9s9.9248,3.0535,13.3441,3.0535S129.8039,95.9,133.2232,95.9s9.9248,3.0535,13.3441,3.0535S156.4921,95.9,159.9114,95.9s9.9248,3.0535,13.3441,3.0535S182.7342,95.9,186.6,95.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M79.8468,91.2652c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M146.934,21.4334l.7054,1.4292a.3851.3851,0,0,0,.29.2107l1.5772.2292a.3853.3853,0,0,1,.2135.6572l-1.1413,1.1124a.3853.3853,0,0,0-.1108.341l.2694,1.5708a.3853.3853,0,0,1-.559.4062l-1.4107-.7417a.3852.3852,0,0,0-.3585,0l-1.4107.7417a.3853.3853,0,0,1-.559-.4062l.2694-1.5708a.3853.3853,0,0,0-.1108-.341L143.4569,23.96a.3853.3853,0,0,1,.2136-.6572l1.5772-.2292a.3851.3851,0,0,0,.29-.2107l.7054-1.4292A.3852.3852,0,0,1,146.934,21.4334Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M124.7313,102.5234a36.677,36.677,0,0,1,8.6386-1.6774c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M79.8468,100.846c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535a35.8023,35.8023,0,0,1,8.4964,1.6739"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M120.1818,100.6971l.7053,1.4292a.3855.3855,0,0,0,.29.2108l1.5772.2291a.3853.3853,0,0,1,.2135.6572l-1.1413,1.1124a.3856.3856,0,0,0-.1108.3411l.2695,1.5708a.3853.3853,0,0,1-.559.4061l-1.4107-.7416a.3854.3854,0,0,0-.3586,0l-1.4107.7416a.3853.3853,0,0,1-.559-.4061l.2694-1.5708a.3853.3853,0,0,0-.1108-.3411l-1.1412-1.1124a.3853.3853,0,0,1,.2135-.6572l1.5772-.2291a.3856.3856,0,0,0,.29-.2108l.7053-1.4292A.3853.3853,0,0,1,120.1818,100.6971Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M173.5041,45.398l.5889,1.1932a.3215.3215,0,0,0,.2421.1759l1.3168.1914a.3216.3216,0,0,1,.1783.5486l-.9528.9288a.3215.3215,0,0,0-.0926.2847l.225,1.3114a.3217.3217,0,0,1-.4667.3391l-1.1778-.6192a.3219.3219,0,0,0-.2993,0l-1.1778.6192a.3216.3216,0,0,1-.4667-.3391l.2249-1.3114a.3217.3217,0,0,0-.0925-.2847l-.9528-.9288a.3216.3216,0,0,1,.1783-.5486l1.3167-.1914a.3215.3215,0,0,0,.2422-.1759l.5889-1.1932A.3217.3217,0,0,1,173.5041,45.398Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M93.2775,54.7432l.6041,1.2241a.33.33,0,0,0,.2485.1806l1.3509.1962a.33.33,0,0,1,.1829.5629l-.9775.9528a.33.33,0,0,0-.0949.2921l.2307,1.3454a.33.33,0,0,1-.4788.3479L93.1351,59.21a.33.33,0,0,0-.3071,0l-1.2082.6352a.33.33,0,0,1-.4788-.3479l.2307-1.3454a.33.33,0,0,0-.0949-.2921l-.9775-.9528a.33.33,0,0,1,.1829-.5629l1.3509-.1962a.33.33,0,0,0,.2484-.1806l.6042-1.2241A.33.33,0,0,1,93.2775,54.7432Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M146.8845,68.654l.6041,1.2241a.33.33,0,0,0,.2485.18l1.3508.1963a.33.33,0,0,1,.1829.5628l-.9775.9529a.33.33,0,0,0-.0949.292l.2308,1.3455a.33.33,0,0,1-.4788.3478l-1.2083-.6352a.33.33,0,0,0-.3071,0l-1.2083.6352a.33.33,0,0,1-.4788-.3478l.2308-1.3455a.33.33,0,0,0-.0949-.292l-.9775-.9529a.33.33,0,0,1,.1829-.5628l1.3509-.1963a.33.33,0,0,0,.2484-.18l.6041-1.2241A.33.33,0,0,1,146.8845,68.654Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M.1492-1.4749c3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536S63.45,1.5787,66.87,1.5787s9.4787-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M.1492,3.162c3.4193,0,9.9248,3.0536,13.3441,3.0536S23.4181,3.162,26.8374,3.162s9.9248,3.0536,13.3441,3.0536S50.1063,3.162,53.5256,3.162,63.45,6.2156,66.87,6.2156,76.3484,3.162,80.2138,3.162"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M.1492,12.434c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535S63.45,15.4875,66.87,15.4875s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M.1492,105.174c3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.4787-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M.1492,17.0728c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535S63.45,20.1263,66.87,20.1263s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M.1492,21.71c3.4193,0,9.9248,3.0535,13.3441,3.0535S23.4181,21.71,26.8374,21.71s9.9248,3.0535,13.3441,3.0535S50.1063,21.71,53.5256,21.71,63.45,24.7632,66.87,24.7632,76.3484,21.71,80.2138,21.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M.1492,26.3466c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535S36.7622,29.4,40.1815,29.4s9.9248-3.0535,13.3441-3.0535S63.45,29.4,66.87,29.4s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M18.3456,9.7852a36.6744,36.6744,0,0,1,8.6386-1.6773c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M.1492,8.1079A35.8006,35.8006,0,0,1,8.6456,9.7817"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M.1492,40.2573c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535S63.45,43.3108,66.87,43.3108s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M71.6121,37.4737C74.8345,36.58,77.5107,35.72,80.25,35.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M.1852,35.5114c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535c2.348,0,5.1533.9259,8.4131,1.8281"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M71.6121,97.8625c3.2224-.8935,5.8986-1.7532,8.6377-1.7532"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M.1852,95.9c3.4193,0,9.9248,3.0535,13.3441,3.0535S23.4541,95.9,26.8734,95.9s9.9248,3.0535,13.3441,3.0535S50.1423,95.9,53.5616,95.9c2.348,0,5.1533.9259,8.4131,1.8282"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M.1492,30.5533c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535S63.45,33.6068,66.87,33.6068s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M.1492,44.8942c3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536S63.45,47.9478,66.87,47.9478s9.4787-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M.122,49.5311c3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.4787-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M.0889,54.168c3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536S50.046,54.168,53.4653,54.168s9.9248,3.0536,13.3441,3.0536,9.4787-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M45.3236,69.9205c3.4654-.8393,5.585-1.8417,8.202-1.8417,3.4193,0,9.9248,3.0535,13.3441,3.0535s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M.1492,68.0788c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535c2.492,0,5.0019,1.1764,8.383,2.0562"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M.1492,63.4419c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535S63.45,66.4954,66.87,66.4954s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M.1221,59.1683c3.4192,0,9.9248,3.0536,13.344,3.0536S23.391,59.1683,26.81,59.1683s9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.4788-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M.1492,77.3526c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535S63.45,80.4061,66.87,80.4061s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M.1492,72.7157c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535S63.45,75.7692,66.87,75.7692s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M.1492,86.6264c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535S36.7622,89.68,40.1815,89.68s9.9248-3.0535,13.3441-3.0535S63.45,89.68,66.87,89.68s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M.1492,81.99c3.4193,0,9.9248,3.0535,13.3441,3.0535S23.4181,81.99,26.8374,81.99s9.9248,3.0535,13.3441,3.0535S50.1063,81.99,53.5256,81.99,63.45,85.043,66.87,85.043,76.3484,81.99,80.2138,81.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M.1492,100.846c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535S36.7622,103.9,40.1815,103.9s9.9248-3.0535,13.3441-3.0535S63.45,103.9,66.87,103.9s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M.1492,91.2652c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535S63.45,94.3187,66.87,94.3187s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M13.796,7.959l.7053,1.4291a.3852.3852,0,0,0,.29.2108l1.5772.2292a.3852.3852,0,0,1,.2135.6571l-1.1412,1.1125a.385.385,0,0,0-.1108.341L15.6,13.51a.3853.3853,0,0,1-.559.4062L13.63,13.174a.3854.3854,0,0,0-.3586,0l-1.4106.7417a.3853.3853,0,0,1-.559-.4062l.2694-1.5708a.3853.3853,0,0,0-.1108-.341l-1.1413-1.1125a.3852.3852,0,0,1,.2135-.6571L12.11,9.5989a.385.385,0,0,0,.29-.2108L13.105,7.959A.3853.3853,0,0,1,13.796,7.959Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M.1492,95.9325a35.8014,35.8014,0,0,1,8.4964,1.6739"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M67.1251,95.7836l.7054,1.4292a.3851.3851,0,0,0,.29.2107l1.5772.2292a.3853.3853,0,0,1,.2135.6572L68.77,99.4223a.3854.3854,0,0,0-.1108.341l.2694,1.5709a.3852.3852,0,0,1-.559.4061l-1.4107-.7416a.3852.3852,0,0,0-.3585,0L65.19,101.74a.3853.3853,0,0,1-.559-.4061L64.9,99.7633a.3854.3854,0,0,0-.1108-.341L63.648,98.31a.3853.3853,0,0,1,.2136-.6572l1.5772-.2292a.3851.3851,0,0,0,.29-.2107l.7054-1.4292A.3852.3852,0,0,1,67.1251,95.7836Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M67.0946,35.3744l.643,1.3028a.3515.3515,0,0,0,.2645.1922l1.4378.2089a.3512.3512,0,0,1,.1946.5991l-1.04,1.0141a.3514.3514,0,0,0-.101.3109l.2456,1.432a.3512.3512,0,0,1-.51.37l-1.286-.6761a.3512.3512,0,0,0-.3269,0l-1.286.6761a.3512.3512,0,0,1-.51-.37l.2456-1.432a.3511.3511,0,0,0-.101-.3109l-1.04-1.0141a.3512.3512,0,0,1,.1947-.5991l1.4378-.2089a.3515.3515,0,0,0,.2644-.1922l.643-1.3028A.3512.3512,0,0,1,67.0946,35.3744Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M40.4987,68.654l.6041,1.2241a.33.33,0,0,0,.2485.18l1.3509.1963a.33.33,0,0,1,.1829.5628l-.9775.9529a.33.33,0,0,0-.0949.292l.2307,1.3455a.33.33,0,0,1-.4788.3478l-1.2082-.6352a.33.33,0,0,0-.3072,0l-1.2082.6352a.33.33,0,0,1-.4788-.3478l.2307-1.3455a.33.33,0,0,0-.0949-.292l-.9775-.9529a.33.33,0,0,1,.1829-.5628l1.3509-.1963a.33.33,0,0,0,.2484-.18l.6042-1.2241A.33.33,0,0,1,40.4987,68.654Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-106.8146-1.4749c3.25,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536S-30.1693-1.4749-26.75-1.4749s9.9248,3.0536,13.3441,3.0536S-3.9272-1.4749-.0618-1.4749"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M-106.8146,3.162c3.25,0,9.9248,3.0536,13.3441,3.0536S-83.5457,3.162-80.1264,3.162s9.9248,3.0536,13.3441,3.0536S-56.8575,3.162-53.4382,3.162s9.9248,3.0536,13.3441,3.0536S-30.1693,3.162-26.75,3.162s9.9248,3.0536,13.3441,3.0536S-3.9272,3.162-.0618,3.162"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-106.8146,12.434c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535S-30.1693,12.434-26.75,12.434s9.9248,3.0535,13.3441,3.0535S-3.9272,12.434-.0618,12.434"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-106.8146,105.174c3.25,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.4787-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M-106.8146,17.0728c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M-106.8146,8.1079c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535S-30.1693,8.1079-26.75,8.1079s9.9248,3.0535,13.3441,3.0535S-3.9272,8.1079-.0618,8.1079"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M-106.8146,26.3466c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535S-70.2016,29.4-66.7823,29.4s9.9248-3.0535,13.3441-3.0535S-43.5134,29.4-40.0941,29.4s9.9248-3.0535,13.3441-3.0535S-16.8252,29.4-13.4059,29.4s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M-106.8146,35.72c3.25,0,9.9248,3.0536,13.3441,3.0536S-83.5457,35.72-80.1264,35.72s9.9248,3.0536,13.3441,3.0536S-56.8575,35.72-53.4382,35.72s9.9248,3.0536,13.3441,3.0536S-30.1693,35.72-26.75,35.72s9.9248,3.0536,13.3441,3.0536S-3.9272,35.72-.0618,35.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M-8.6995,46.972c3.2224-.8936,5.8985-1.7533,8.6377-1.7533"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M-106.8146,40.2573c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M-106.8146,30.5533c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M-88.4384,55.8681c3.3379-.8912,5.8475-1.7,8.2848-1.7,3.4193,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.344,3.0536,9.9249-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536S-3.9544,54.168-.0891,54.168"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M-106.8749,49.5311c3.25,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.344,3.0536,9.9249-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536S-30.23,49.5311-26.81,49.5311s9.9248,3.0536,13.3441,3.0536,9.4788-3.0536,13.3441-3.0536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M-34.9521,69.9205c3.4655-.8393,5.585-1.8417,8.2021-1.8417,3.4193,0,9.9248,3.0535,13.3441,3.0535s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M-34.9521,23.4241c3.4655-.8394,5.585-1.8418,8.2021-1.8418,3.4193,0,9.9248,3.0535,13.3441,3.0535s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M-106.8146,63.4419c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M-106.8418,59.1683c3.25,0,9.9248,3.0536,13.3441,3.0536s9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536,9.9248-3.0536,13.3441-3.0536,9.9248,3.0536,13.3441,3.0536S-3.9544,59.1683-.089,59.1683"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M-106.8146,77.3526c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M-106.8146,72.7157c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M-106.8146,86.6264c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535S-70.2016,89.68-66.7823,89.68s9.9248-3.0535,13.3441-3.0535S-43.5134,89.68-40.0941,89.68s9.9248-3.0535,13.3441-3.0535S-16.8252,89.68-13.4059,89.68s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M-106.8146,81.99c3.25,0,9.9248,3.0535,13.3441,3.0535S-83.5457,81.99-80.1264,81.99s9.9248,3.0535,13.3441,3.0535S-56.8575,81.99-53.4382,81.99s9.9248,3.0535,13.3441,3.0535S-30.1693,81.99-26.75,81.99s9.9248,3.0535,13.3441,3.0535S-3.9272,81.99-.0618,81.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M-106.8146,95.9c3.25,0,9.9248,3.0535,13.3441,3.0535S-83.5457,95.9-80.1264,95.9s9.9248,3.0535,13.3441,3.0535S-56.8575,95.9-53.4382,95.9s9.9248,3.0535,13.3441,3.0535S-30.1693,95.9-26.75,95.9s9.9248,3.0535,13.3441,3.0535S-3.9272,95.9-.0618,95.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-106.8146,91.2652c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M-61.93,102.5234a36.677,36.677,0,0,1,8.6386-1.6774c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535S-16.6785,103.9-13.2592,103.9-3.78,100.846.0849,100.846"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M186.8107-1.5787c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.344,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.4788-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M79.8468-1.5787c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535S182.7342-1.5787,186.6-1.5787"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M.1492-1.5787c3.4193,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535S63.45,1.4748,66.87,1.4748s9.4787-3.0535,13.3441-3.0535"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M-106.8146-1.5787c3.25,0,9.9248,3.0535,13.3441,3.0535s9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535,9.9248-3.0535,13.3441-3.0535,9.9248,3.0535,13.3441,3.0535S-30.1693-1.5787-26.75-1.5787s9.9248,3.0535,13.3441,3.0535S-3.9272-1.5787-.0618-1.5787"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "h",
    width: 106.7528,
    height: 106.7528,
    patternTransform: "translate(-175.8394 457.8702) rotate(-180)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 106.753 106.753"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 106.7528,
    height: 106.7528
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M106.7524,110.382c-2.6972,0-6.1474-1.1259-10.1416-2.43-4.9238-1.607-10.5048-3.4283-15.7939-3.4283-3.9238,0-7.6953,1.295-11.6865,2.6656-4.57,1.57-9.2959,3.1928-14.9131,3.1928-5.7617,0-11.5664-1.5844-17.1807-3.1167-5.166-1.41-10.0459-2.7417-14.4912-2.7417-4.7558,0-8.72,1.6133-12.5527,3.1739-3.3916,1.38-6.5948,2.6845-9.9922,2.6845v-1.4c3.123,0,6.2031-1.2534,9.4639-2.581,3.7734-1.5361,8.0507-3.2774,13.081-3.2774,4.6328,0,9.6006,1.356,14.86,2.7916,5.5244,1.5078,11.2373,3.0668,16.8115,3.0668,5.3828,0,9.9961-1.5839,14.458-3.1162,4.1055-1.41,7.9834-2.7422,12.1416-2.7422,5.5117,0,11.2051,1.8584,16.2285,3.4981,3.8809,1.2666,7.2324,2.36,9.707,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M106.7524,51.7758c-5.6855,0-9.289-1.5059-12.7734-2.9629-2.9932-1.2505-5.8193-2.4322-9.6963-2.4322-6.4931,0-13.2783,1.668-19.2646,3.1392-4.9258,1.2105-9.18,2.2559-12.5508,2.2559-6.95,0-12.62-1.524-18.1035-2.9976-4.586-1.2329-8.918-2.3975-13.3682-2.3975a23.3277,23.3277,0,0,0-10.8467,2.7525A22.1285,22.1285,0,0,1,.0005,51.7758v-.8c4.26,0,6.957-1.2476,9.8125-2.5689a24.0067,24.0067,0,0,1,11.1826-2.8262c4.5557,0,8.9375,1.1778,13.5762,2.4244,5.4326,1.46,11.0508,2.9707,17.8955,2.9707,3.2744,0,7.4844-1.0347,12.3594-2.2329,6.03-1.4825,12.8652-3.1622,19.456-3.1622,4.0371,0,6.9356,1.2115,10.0049,2.4942a29.2756,29.2756,0,0,0,12.4648,2.9009Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M53.3765,47.1224c-7.0909,0-12.6709-1.8969-17.5928-3.57-3.8291-1.3012-7.1358-2.4253-10.4131-2.4253a30.3524,30.3524,0,0,0-12.3164,2.41A32.461,32.461,0,0,1,.0005,46.0678v-1.4A30.8783,30.8783,0,0,0,12.562,42.2255a31.9175,31.9175,0,0,1,12.8086-2.4991c3.5088,0,6.917,1.1587,10.8633,2.5005,4.82,1.6382,10.2832,3.4952,17.1426,3.4952,5.2343,0,10.333-1.5552,15.2636-3.0591,4.95-1.51,9.626-2.9366,14.4512-2.9366a26.1151,26.1151,0,0,1,12.1572,2.5352,24.4406,24.4406,0,0,0,11.5039,2.4058v1.4A25.9187,25.9187,0,0,1,94.69,43.5453a24.63,24.63,0,0,0-11.5986-2.4185c-4.6172,0-9.1953,1.3965-14.043,2.875C64.02,45.536,58.82,47.1224,53.3765,47.1224Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M106.7524,41.6224c-2.7451,0-6.2158-1.1328-10.2353-2.4448-4.9024-1.6-10.459-3.4136-15.7-3.4136-3.874,0-7.6221,1.2872-11.59,2.65-4.5928,1.5772-9.3428,3.2085-15.01,3.2085-5.8018,0-11.627-1.59-17.26-3.1269C31.811,37.0907,26.9507,35.764,22.5454,35.764c-4.6973,0-8.6338,1.6021-12.44,3.1519C6.686,40.308,3.4565,41.6224.0005,41.6224v-2c3.0644,0,6.1182-1.2431,9.3506-2.559,3.8-1.5464,8.1054-3.2994,13.1943-3.2994,4.6729,0,9.6592,1.3609,14.94,2.8018,5.5048,1.5029,11.1982,3.0566,16.7324,3.0566,5.333,0,9.9219-1.5761,14.36-3.1,4.13-1.4184,8.0313-2.7583,12.2393-2.7583,5.56,0,11.2773,1.8663,16.3213,3.5127,3.8564,1.2588,7.1875,2.3457,9.6142,2.3457Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M106.7524,3.6293c-2.6972,0-6.1474-1.126-10.1416-2.43C91.687-.4078,86.106-2.2291,80.8169-2.2291c-3.9238,0-7.6953,1.2949-11.6865,2.6655-4.57,1.57-9.2959,3.1929-14.9131,3.1929-5.7617,0-11.5664-1.5845-17.1807-3.1167-5.166-1.41-10.0459-2.7417-14.4912-2.7417-4.7558,0-8.72,1.6133-12.5527,3.1738C6.6011,2.3251,3.3979,3.6293.0005,3.6293v-1.4c3.123,0,6.2031-1.2534,9.4639-2.5811,3.7734-1.5361,8.0507-3.2773,13.081-3.2773,4.6328,0,9.6006,1.3559,14.86,2.7915C42.93.67,48.6431,2.2289,54.2173,2.2289c5.3828,0,9.9961-1.584,14.458-3.1162,4.1055-1.41,7.9834-2.7422,12.1416-2.7422,5.5117,0,11.2051,1.8584,16.2285,3.498,3.8809,1.2666,7.2324,2.36,9.707,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M106.7524,110.3822c-2.6972,0-6.1474-1.126-10.1416-2.43-4.9238-1.6069-10.5048-3.4282-15.7939-3.4282-3.9238,0-7.6953,1.2949-11.6865,2.6655-4.57,1.57-9.2959,3.1929-14.9131,3.1929-5.7617,0-11.5664-1.5845-17.1807-3.1167-5.166-1.41-10.0459-2.7417-14.4912-2.7417-4.7558,0-8.72,1.6133-12.5527,3.1738-3.3916,1.38-6.5948,2.6846-9.9922,2.6846v-1.4c3.123,0,6.2031-1.2534,9.4639-2.581,3.7734-1.5362,8.0507-3.2774,13.081-3.2774,4.6328,0,9.6006,1.356,14.86,2.7915,5.5244,1.5078,11.2373,3.0669,16.8115,3.0669,5.3828,0,9.9961-1.584,14.458-3.1162,4.1055-1.41,7.9834-2.7422,12.1416-2.7422,5.5117,0,11.2051,1.8584,16.2285,3.4981,3.8809,1.2666,7.2324,2.36,9.707,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M53.3765,36.5248c-7.2071,0-12.8448-1.9165-17.8184-3.6069-3.7705-1.2818-7.0264-2.3887-10.1875-2.3887A29.7583,29.7583,0,0,0,13.3,32.8944,33.0563,33.0563,0,0,1,.0005,35.47v-2.8a30.2865,30.2865,0,0,0,12.3154-2.3975,32.517,32.517,0,0,1,13.0547-2.5434c3.624,0,7.25,1.2324,11.0889,2.5371,4.7685,1.6211,10.1728,3.4585,16.917,3.4585,5.13,0,10.1777-1.54,15.06-3.0293,4.7813-1.4585,9.7256-2.9663,14.6553-2.9663a26.7176,26.7176,0,0,1,12.4365,2.5928A23.8433,23.8433,0,0,0,106.7524,32.67v2.8a26.5216,26.5216,0,0,1-12.3418-2.58,24.0342,24.0342,0,0,0-11.3193-2.3608c-4.5127,0-9.042,1.3818-13.8379,2.8447C64.1753,34.9232,58.9243,36.5248,53.3765,36.5248Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M106.7524,31.4144A31.455,31.455,0,0,1,93.4771,28.351c-2.9932-1.251-5.5782-2.3316-9.1944-2.3316-5.7236,0-10.86,1.3648-15.8271,2.6846-5.0147,1.3325-10.1993,2.71-15.9883,2.71-7.16,0-12.2949-1.6279-16.8252-3.0634-3.9463-1.2515-7.3555-2.3316-11.5957-2.3316-4.6817,0-8.2393,1.3042-12.0068,2.6856C8.4067,30.037,4.65,31.4144.0005,31.4144v-3.4c4.0459,0,7.36-1.2148,10.8691-2.5014,3.88-1.4224,7.8916-2.8936,13.1768-2.8936,4.7666,0,8.583,1.21,12.623,2.4908,4.5049,1.4277,9.1641,2.9042,15.7979,2.9042,5.3447,0,10.0908-1.2607,15.1152-2.5957,5.1778-1.3764,10.5332-2.7993,16.7-2.7993,4.2979,0,7.4541,1.3194,10.5059,2.5948a28.19,28.19,0,0,0,11.9638,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M53.3765,26.4193c-7.3223,0-13.0186-1.9365-18.044-3.6445-3.7109-1.2617-6.916-2.3511-9.9619-2.3511a26.3116,26.3116,0,0,0-11.7471,2.5894,30.6946,30.6946,0,0,1-13.623,2.955v-4.2a26.7887,26.7887,0,0,0,11.9922-2.6255,30.2108,30.2108,0,0,1,13.3779-2.919c3.74,0,7.419,1.25,11.3135,2.5747,4.7178,1.6035,10.0644,3.4209,16.6924,3.4209,5.0078,0,9.6894-1.5107,14.2158-2.9721,4.5576-1.4712,9.27-2.9922,14.3213-2.9922a28.7342,28.7342,0,0,1,13.3135,2.9414,24.6564,24.6564,0,0,0,11.5253,2.5718v4.2a28.54,28.54,0,0,1-13.2158-2.9272,24.8487,24.8487,0,0,0-11.623-2.5859c-4.3907,0-8.5879,1.3545-13.0313,2.789C64.0464,24.8051,59.0454,26.4193,53.3765,26.4193Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M106.7524,20.6639c-4.0136,0-7.7441-1.3569-11.6933-2.7929-4.1084-1.4937-8.3565-3.0381-13.1182-3.0381-3.7754,0-7.7285,1.2676-11.914,2.61-4.9375,1.5835-10.044,3.2211-15.81,3.2211-5.9111,0-11.4209-1.6064-16.75-3.16-4.7617-1.3882-9.2588-2.6987-13.5557-2.6987-4.5869,0-8.8515,1.5854-12.9765,3.1186-3.7891,1.4087-7.3682,2.74-10.9346,2.74v-3.4c2.9551,0,6.2558-1.2271,9.75-2.5264,4.2012-1.5615,8.9629-3.332,14.1611-3.332,4.7822,0,9.5059,1.3769,14.5069,2.8349,5.1,1.4863,10.374,3.0235,15.7988,3.0235,5.2344,0,10.082-1.5547,14.7715-3.0586,4.4453-1.4258,8.6455-2.7725,12.9521-2.7725,5.3613,0,10.1,1.7231,14.2793,3.2432,3.66,1.331,7.1172,2.5879,10.5322,2.5879Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M106.7524,15.25A31.19,31.19,0,0,1,93.5933,12.21C90.57,10.9462,87.96,9.8549,84.2827,9.8549c-6.3887,0-12.8379,1.4257-18.5273,2.684-4.7774,1.0562-8.9033,1.9683-12.3789,1.9683-7.11,0-12.7862-1.7627-17.793-3.3179C31.3335,9.869,27.32,8.6224,23.03,8.6224c-4.6621,0-7.9629,1.5967-11.4561,3.2872C8.1792,13.5521,4.6685,15.25.0005,15.25v-2.8c4.0264,0,7.1-1.4868,10.3535-3.0611C13.978,7.6356,17.7251,5.8226,23.03,5.8226c4.7148,0,8.9258,1.3077,13.3838,2.6924,5.0527,1.5694,10.2773,3.1924,16.9629,3.1924,3.17,0,7.1572-.8818,11.7744-1.9028,5.8291-1.2886,12.4365-2.75,19.1318-2.75,4.2383,0,7.3652,1.3071,10.39,2.5717a28.4477,28.4477,0,0,0,12.08,2.8238Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M53.3765,8.9657c-7.1407,0-12.7452-1.9053-17.69-3.5859-3.8037-1.293-7.0889-2.41-10.3164-2.41A30.0928,30.0928,0,0,0,13.16,5.3607,32.7078,32.7078,0,0,1,.0005,7.911v-2a30.6257,30.6257,0,0,0,12.456-2.4228A32.1767,32.1767,0,0,1,25.3706.97c3.5586,0,7.1533,1.2222,10.96,2.5161,4.7978,1.6309,10.2363,3.48,17.0459,3.48,5.1894,0,10.2666-1.5488,15.1767-3.0464C73.3062,2.47,78.2212.97,83.0913.97A26.3611,26.3611,0,0,1,95.3677,3.53,24.1944,24.1944,0,0,0,106.7524,5.911v2A26.1847,26.1847,0,0,1,94.57,5.3641,24.3648,24.3648,0,0,0,83.0913,2.97c-4.5723,0-9.13,1.39-13.9551,2.8623C64.0864,7.3729,58.8638,8.9657,53.3765,8.9657Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M106.7524,105.1483c-5.6855,0-9.289-1.5063-12.7734-2.9629-2.9932-1.2509-5.8193-2.4326-9.6963-2.4326-6.4931,0-13.2783,1.668-19.2646,3.1392-4.9258,1.2109-9.18,2.2563-12.5508,2.2563-6.95,0-12.62-1.5239-18.1035-2.998-4.586-1.2329-8.918-2.3975-13.3682-2.3975a23.3214,23.3214,0,0,0-10.8467,2.7529A22.1273,22.1273,0,0,1,.0005,105.1483v-.8c4.26,0,6.957-1.248,9.8125-2.5688A23.9991,23.9991,0,0,1,20.9956,98.953c4.5557,0,8.9375,1.1777,13.5762,2.4248,5.4326,1.4605,11.0508,2.9707,17.8955,2.9707,3.2744,0,7.4844-1.0351,12.3594-2.2334,6.03-1.4819,12.8652-3.1621,19.456-3.1621,4.0371,0,6.9356,1.2114,10.0049,2.4942,3.4111,1.4262,6.9395,2.9013,12.4648,2.9013Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M53.3765,101.4945c-7.0909,0-12.6709-1.8965-17.5928-3.57-3.8291-1.3018-7.1358-2.4253-10.4131-2.4253a30.3507,30.3507,0,0,0-12.3164,2.41A32.4612,32.4612,0,0,1,.0005,100.44v-1.4A30.8766,30.8766,0,0,0,12.562,96.598a31.9178,31.9178,0,0,1,12.8086-2.499c3.5088,0,6.917,1.1587,10.8633,2.5,4.82,1.6382,10.2832,3.4951,17.1426,3.4951,5.2343,0,10.333-1.5552,15.2636-3.0591,4.95-1.51,9.626-2.936,14.4512-2.936a26.1151,26.1151,0,0,1,12.1572,2.5352A24.4409,24.4409,0,0,0,106.7524,99.04v1.4A25.919,25.919,0,0,1,94.69,97.9179a24.63,24.63,0,0,0-11.5986-2.4185c-4.6172,0-9.1953,1.3965-14.043,2.875C64.02,99.9081,58.82,101.4945,53.3765,101.4945Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M106.7524,96.9711c-2.7451,0-6.2158-1.1328-10.2353-2.4448-4.9024-1.6-10.459-3.4136-15.7-3.4136-3.874,0-7.6221,1.2871-11.59,2.65-4.5928,1.5771-9.3428,3.2085-15.01,3.2085-5.8018,0-11.627-1.59-17.26-3.127-5.1465-1.4048-10.0068-2.7314-14.4121-2.7314-4.6973,0-8.6338,1.602-12.44,3.1518C6.686,95.6566,3.4565,96.9711.0005,96.9711v-2c3.0644,0,6.1182-1.2432,9.3506-2.5591,3.8-1.5464,8.1054-3.2993,13.1943-3.2993,4.6729,0,9.6592,1.3608,14.94,2.8017,5.5048,1.503,11.1982,3.0567,16.7324,3.0567,5.333,0,9.9219-1.5762,14.36-3.1,4.13-1.4185,8.0313-2.7583,12.2393-2.7583,5.56,0,11.2773,1.8662,16.3213,3.5127,3.8564,1.2588,7.1875,2.3457,9.6142,2.3457Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M106.7524,58.1249c-2.6972,0-6.1474-1.126-10.1416-2.43-4.9238-1.6069-10.5048-3.4282-15.7939-3.4282-3.9238,0-7.6953,1.2949-11.6865,2.6655-4.57,1.57-9.2959,3.1929-14.9131,3.1929-5.7617,0-11.5664-1.5845-17.1807-3.1167-5.166-1.41-10.0459-2.7417-14.4912-2.7417-4.7558,0-8.72,1.6133-12.5527,3.1738-3.3916,1.38-6.5948,2.6846-9.9922,2.6846v-1.4c3.123,0,6.2031-1.2534,9.4639-2.5811,3.7734-1.5361,8.0507-3.2773,13.081-3.2773,4.6328,0,9.6006,1.356,14.86,2.7915,5.5244,1.5078,11.2373,3.0669,16.8115,3.0669,5.3828,0,9.9961-1.584,14.458-3.1162,4.1055-1.41,7.9834-2.7422,12.1416-2.7422,5.5117,0,11.2051,1.8584,16.2285,3.498,3.8809,1.2666,7.2324,2.36,9.707,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M53.3765,92.8969c-7.2071,0-12.8448-1.9161-17.8184-3.607-3.7705-1.2812-7.0264-2.3882-10.1875-2.3882A29.7581,29.7581,0,0,0,13.3,89.267a33.0563,33.0563,0,0,1-13.3,2.5757v-2.8a30.2865,30.2865,0,0,0,12.3154-2.3975,32.5168,32.5168,0,0,1,13.0547-2.5435c3.624,0,7.25,1.2325,11.0889,2.5371,4.7685,1.6207,10.1728,3.4581,16.917,3.4581,5.13,0,10.1777-1.54,15.06-3.0289,4.7813-1.4584,9.7256-2.9663,14.6553-2.9663a26.7189,26.7189,0,0,1,12.4365,2.5928,23.8431,23.8431,0,0,0,11.2246,2.3482v2.8a26.5228,26.5228,0,0,1-12.3418-2.58,24.0328,24.0328,0,0,0-11.3193-2.3609c-4.5127,0-9.042,1.3819-13.8379,2.8448C64.1753,91.2953,58.9243,92.8969,53.3765,92.8969Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M106.7524,87.787c-4.7949,0-8.5332-1.4565-12.1474-2.8652-3.34-1.3013-6.4942-2.53-10.3223-2.53-6.3359,0-13.04,1.6474-18.9551,3.1016-5.0068,1.2309-9.332,2.2939-12.86,2.2939-7.1777,0-12.4248-1.7778-17.0537-3.3462-4.0244-1.3633-7.5-2.54-11.7227-2.54-4.6484,0-8.1045,1.4165-11.7637,2.9165-3.5615,1.46-7.2441,2.97-11.9267,2.97v-3.4c4.0127,0,7.2305-1.3188,10.6377-2.7158C14.4409,80.1122,18.3726,78.5,23.6909,78.5c4.7832,0,8.6836,1.3218,12.8135,2.7207,4.5947,1.5566,9.3457,3.166,15.9629,3.166,3.1172,0,7.456-1.0664,12.0488-2.1953,6.1026-1.5,13.0186-3.2,19.7666-3.2,4.4668,0,8.0713,1.4043,11.5567,2.7627,3.4746,1.354,6.7568,2.6328,10.913,2.6328Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M53.3765,82.3c-7.3223,0-13.0186-1.9365-18.044-3.6446-3.7109-1.2617-6.916-2.351-9.9619-2.351a29.1644,29.1644,0,0,0-11.8242,2.32A33.6509,33.6509,0,0,1,.0005,81.2455v-4.2A29.6983,29.6983,0,0,0,12.07,74.6928a33.1145,33.1145,0,0,1,13.3008-2.5884c3.74,0,7.419,1.2505,11.3135,2.5747C41.4019,76.2826,46.7485,78.1,53.3765,78.1c5.0254,0,10.0224-1.5244,14.8554-2.9986,4.83-1.4731,9.8252-2.997,14.8594-2.997a27.3005,27.3005,0,0,1,12.7149,2.6513,23.2632,23.2632,0,0,0,10.9462,2.29v4.2a27.1274,27.1274,0,0,1-12.6211-2.6382,23.4334,23.4334,0,0,0-11.04-2.3027c-4.4082,0-8.89,1.3667-13.6338,2.8144C64.33,80.683,59.0278,82.3,53.3765,82.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M106.7524,75.9047c-2.8564,0-6.3759-1.149-10.4521-2.48-4.8525-1.584-10.3535-3.3789-15.4834-3.3789-3.7578,0-7.4512,1.2685-11.3623,2.6113-4.6475,1.5962-9.4531,3.2471-15.2373,3.2471-5.8955,0-11.7666-1.6026-17.4434-3.1519-5.1006-1.3921-9.917-2.7065-14.2285-2.7065-4.5605,0-8.4316,1.5757-12.1758,3.1C6.8853,74.5648,3.5933,75.9047.0005,75.9047v-3.4c2.9277,0,5.9189-1.2178,9.0869-2.5073,3.8584-1.57,8.2324-3.3511,13.458-3.3511,4.7666,0,9.7979,1.373,15.1231,2.8266,5.4619,1.4908,11.1084,3.0318,16.5488,3.0318,5.2158,0,9.749-1.5567,14.1328-3.062,4.1875-1.438,8.1416-2.7964,12.4668-2.7964,5.6709,0,11.4443,1.8847,16.5381,3.5473,3.6416,1.1885,7.082,2.3111,9.3974,2.3111Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M106.7524,69.746a31.1913,31.1913,0,0,1-13.1591-3.04c-3.0235-1.2637-5.6338-2.355-9.3106-2.355-6.3721,0-13.0947,1.6523-19.0264,3.11-4.9882,1.2261-9.2968,2.2852-12.789,2.2852-7.082,0-13.0752-1.6109-18.3633-3.0322-4.52-1.2154-8.79-2.3633-13.1084-2.3633a22.2012,22.2012,0,0,0-10.4268,2.6606A22.9661,22.9661,0,0,1,.0005,69.746v-2.8c4.0391,0,6.64-1.2031,9.3926-2.4766a24.8391,24.8391,0,0,1,11.6025-2.9189c4.6875,0,9.1309,1.1943,13.8359,2.459,5.37,1.4438,10.9229,2.9365,17.6358,2.9365,3.1533,0,7.5088-1.0708,12.1211-2.2041,6.0849-1.4961,12.9824-3.1914,19.6943-3.1914,4.2383,0,7.3652,1.3071,10.39,2.5717a28.4477,28.4477,0,0,0,12.08,2.8238Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M53.3765,63.4613c-7.1407,0-12.7452-1.9053-17.69-3.5859-3.8037-1.293-7.0889-2.41-10.3164-2.41A30.0928,30.0928,0,0,0,13.16,59.8563a32.7078,32.7078,0,0,1-13.1592,2.55v-2a30.6257,30.6257,0,0,0,12.456-2.4228,32.1767,32.1767,0,0,1,12.9141-2.5181c3.5586,0,7.1533,1.2222,10.96,2.5161,4.7978,1.6309,10.2363,3.48,17.0459,3.48,5.1894,0,10.2666-1.5488,15.1767-3.0464,4.753-1.45,9.668-2.9492,14.5381-2.9492a26.3611,26.3611,0,0,1,12.2764,2.56,24.1944,24.1944,0,0,0,11.3847,2.3808v2A26.1862,26.1862,0,0,1,94.57,59.86a24.3633,24.3633,0,0,0-11.4785-2.3941c-4.5723,0-9.13,1.39-13.9551,2.8623C64.0864,61.8685,58.8638,63.4613,53.3765,63.4613Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M106.7524,3.63c-2.6972,0-6.1474-1.126-10.1416-2.43C91.687-.4077,86.106-2.2289,80.8169-2.2289,76.8931-2.2289,73.1216-.934,69.13.4366,64.56,2.0064,59.8345,3.63,54.2173,3.63,48.4556,3.63,42.6509,2.045,37.0366.5128c-5.166-1.41-10.0459-2.7417-14.4912-2.7417-4.7558,0-8.72,1.6132-12.5527,3.1738C6.6011,2.3253,3.3979,3.63.0005,3.63v-1.4c3.123,0,6.2031-1.2535,9.4639-2.5811,3.7734-1.5361,8.0507-3.2773,13.081-3.2773,4.6328,0,9.6006,1.3559,14.86,2.7915C42.93.67,48.6431,2.2291,54.2173,2.2291c5.3828,0,9.9961-1.584,14.458-3.1162,4.1055-1.41,7.9834-2.7422,12.1416-2.7422,5.5117,0,11.2051,1.8584,16.2285,3.498,3.8809,1.2666,7.2324,2.36,9.707,2.36Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "t"
  }, /*#__PURE__*/React.createElement("g", {
    className: "u"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "v",
    cx: 65.2059,
    cy: 65.3467,
    r: 57.7278
  }), /*#__PURE__*/React.createElement("circle", {
    className: "w",
    cx: 65.2059,
    cy: 65.3467,
    r: 57.7278
  }), /*#__PURE__*/React.createElement("circle", {
    className: "x",
    cx: 65.2059,
    cy: 65.3467,
    r: 57.7278
  }), /*#__PURE__*/React.createElement("circle", {
    className: "y",
    cx: 65.2059,
    cy: 65.3467,
    r: 57.7278
  })), /*#__PURE__*/React.createElement("g", {
    className: "z"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "aa",
    cx: 65.1286,
    cy: 65.143,
    r: 57.7278
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ab",
    cx: 65.1286,
    cy: 65.143,
    r: 57.7278
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ac",
    cx: 65.1286,
    cy: 65.143,
    r: 57.7278
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ad",
    cx: 65.1286,
    cy: 65.143,
    r: 57.7278
  })), /*#__PURE__*/React.createElement("g", {
    className: "ae"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "af",
    cx: 65.2916,
    cy: 65.143,
    r: 57.7278
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ag",
    cx: 65.2916,
    cy: 65.143,
    r: 57.7278
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ah",
    cx: 65.2916,
    cy: 65.143,
    r: 57.7278
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ai",
    cx: 65.2916,
    cy: 65.143,
    r: 57.7278
  })), /*#__PURE__*/React.createElement("line", {
    className: "aj",
    x1: 64.999,
    y1: 1.4843,
    x2: 64.999,
    y2: 66.0602
  }), /*#__PURE__*/React.createElement("line", {
    className: "ak",
    x1: 64.999,
    y1: 65.8523,
    x2: 10.3031,
    y2: 97.431
  }), /*#__PURE__*/React.createElement("line", {
    className: "al",
    x1: 64.999,
    y1: 65.6783,
    x2: 119.9962,
    y2: 97.431
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceCjr);
export default __webpack_public_path__ + "static/media/space-CJR.fbfb8037d4f3d5f01a1701583cb9fb23.svg";
export { ForwardRef as ReactComponent };